// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-21T21:36:49.721Z
// Property: One Lakefront (ID: 6767906449167762)
// Collections: 41 amenities, 8 floorplans (live), 17 photos, 76 POIs, 5 reviews, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162273",
  "multihub_property_id": "6767906449167762",
  "property_external_id": "1654449",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/one-lakefront-seattle-wa/7yvbetw/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "one-lakefront",
  "property_name": "One Lakefront",
  "property_website_url": "https://www.hollandresidential.com/wa/seattle/one-lakefront",
  "property_domain": null,
  "property_address": "1287 Westlake Ave N",
  "property_full_address": "1287 Westlake Ave N, Seattle, WA 98109",
  "property_address_1": "1287 Westlake Ave N",
  "property_address_2": null,
  "property_address_city": "Seattle",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98109",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Westlake",
  "property_address_latitude": "47.6320077",
  "property_address_longitude": "-122.3416828",
  "property_email": "206bell@weidner.com",
  "property_phone": "(564) 262-7782",
  "property_call_tracking_phone": null,
  "property_company_name": "Repli Sandbox",
  "property_company_url": "testurl.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Waterfront energy, elevated daily.</strong> On Lake Union’s Westlake edge, One Lakefront pairs skyline-and-water views with polished apartment finishes and connected indoor-outdoor spaces. Explore <a href=\"/floor-plans\">available floor plans</a>, browse <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see home, lake, and city come together.</p>",
  "property_long_description": "<p><strong>Waterfront energy, elevated daily.</strong> One Lakefront places you on Lake Union’s Westlake edge, where skyline views, marinas, and the Cheshiahud Lake Union Loop create a distinctly Seattle backdrop. Start with rooftop terraces overlooking the water, outdoor kitchens and fire pit seating, then head downstairs for reservation-only kayaks and paddle boards, a fitness center with yoga studio, pet parks, bike storage, and indoor access to both Westlake and Dexter.</p><p>Inside, choose from efficient urban one-bedrooms, loft and den layouts, spacious two-bedrooms, and three-bedroom homes with polished finishes: quartz counters, stainless steel appliances, soft-close cabinetry, California Closets systems, hard-surface flooring, full-size laundry, and select private balconies. Beyond the building, Lake Union Park, MOHAI, the Center for Wooden Boats, South Lake Union dining, Queen Anne, Fremont, and the SLU Streetcar keep the city close without losing the water’s edge. Explore <a href=\"/floor-plans\">available floor plans</a>, <a href=\"/amenities\">amenities</a>, and the <a href=\"/neighborhood\">neighborhood</a> to see how One Lakefront connects home, lake, and city.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-c9b4-72df-84c5-332b1209df53.webp",
  "property_featured_image_media": {
    "alt_text": "Building exterior with balconies and signage '206 BELL'",
    "public_id": "01a15af3-c9b4-72df-84c5-332b1209df53",
    "storage_key": "property/6767906449167762/01a15af3-c9b4-72df-84c5-332b1209df53.webp",
    "width": 2560,
    "height": 1468
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "25",
  "property_fees_deposit_info": "Security deposit: $450",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Cats and dogs allowed, up to 200 lb each. Maximum 2 pets per unit.",
  "property_pet_policy_description": "Cats and dogs allowed, up to 200 lb each. Maximum 2 pets per unit. Pet deposit: $300 per pet. Monthly pet rent: $50 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://206bell.securecafe.com/onlineleasing/206-bell-0/floorplans.aspx",
  "property_resident_portal_url": "https://206bell.securecafenet.com/residentservices/206-bell-0/userlogin",
  "property_apply_now_url": "https://206bell.securecafe.com/onlineleasing/206-bell-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ff61-769f-ab46-1785b64ce5e7.webp",
  "property_primary_logo_media": {
    "alt_text": "One Lakefront logo",
    "public_id": "01a15ad9-ff61-769f-ab46-1785b64ce5e7",
    "storage_key": "property/6767906449167762/01a15ad9-ff61-769f-ab46-1785b64ce5e7.webp",
    "width": 481,
    "height": 285
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ada-4ba8-766d-b8cb-7cb7c66a016b.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a15ada-4ba8-766d-b8cb-7cb7c66a016b",
    "storage_key": "property/6767906449167762/01a15ada-4ba8-766d-b8cb-7cb7c66a016b.webp",
    "width": 481,
    "height": 285
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ada-3286-759a-8ec9-263b13b7af12.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a15ada-3286-759a-8ec9-263b13b7af12",
    "storage_key": "property/6767906449167762/01a15ada-3286-759a-8ec9-263b13b7af12.webp",
    "width": 481,
    "height": 285
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019cfdd9-c8a4-71d3-8bff-111ee22aee5d.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2713-d4f5-701a-91f4-9c4e82dc6c6b.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019d2705-ea93-721c-8d4f-e2d2a439a839.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": null,
  "property_secondary_color": null,
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": null,
  "property_bedrooms_min": null,
  "property_bedrooms_max": null,
  "property_bathrooms_range": null,
  "property_bathrooms_min": null,
  "property_bathrooms_max": null,
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ-3jKlj0VkFQRqPftEq3QAnA",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to One Lakefront",
  "property_home_romance_title": "Embrace Your New Life in a Cherished Community",
  "property_home_amenities_blurb": "<p><strong>Lake Union amenities, built into the day.</strong> Start with yoga, head to a rooftop terrace for dinner by the grills, then unwind by the fire pit or reserve a kayak or paddle board. Two rooftop decks frame the water with outdoor kitchens, dining space, TVs, and lounge seating, while The Boardroom brings a vintage-inspired mix of pool, liquor lockers, and a large-screen TV. Polished interiors, pet parks, bike storage, package lockers, and indoor Westlake-to-Dexter access keep convenience close.</p>",
  "property_home_floorplans_blurb": "<p><strong>Floor plans with room to make Westlake feel effortless.</strong> Explore one-bedroom, den, loft, two-bedroom, and three-bedroom layouts with open living areas, hard-surface flooring, full-size laundry, stainless steel appliances, quartz countertops, soft-close cabinetry, and custom California Closets systems. Select homes add high ceilings, a second bath, or a private patio or balcony.</p>",
  "property_home_gallery_blurb": "<p><strong>See One Lakefront in focus.</strong> Preview polished interiors with quartz counters, stainless steel appliances, hard-surface flooring, and select balconies that pull Lake Union closer. Then picture rooftop terraces with grills and open-air dining, a courtyard fireplace pavilion, glassy lounge spaces, a vintage-inspired Boardroom with a pool table, and fitness spaces built for an active Westlake setting.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Lake Union at your doorstep, Seattle within easy reach.</strong> One Lakefront puts Westlake’s shoreline energy close: marina docks, floatplanes, waterside coffee, and seafood favorites like Duke’s and The White Swan. Bike lanes, bus connections, Lake Union Park, MOHAI, downtown, Seattle Center, Queen Anne, and Fremont are all an easy hop away—while home stays anchored on the calmer west edge of the lake.</p>",
  "property_home_reviews_blurb": "<p><strong>Resident reviews say it best:</strong> One Lakefront stands out for responsive service, quick maintenance, and a leasing experience that feels easy from tour to move-in.</p><p>Neighbors also call out quiet apartments, polished common spaces, and standout Lake Union views—plus a “top notch” team that keeps the building feeling cared for every day. Read more to see what daily life in Westlake looks like here.</p>",
  "property_neighborhood_blurb": "<p><strong>Follow the shoreline, then follow your mood.</strong> From One Lakefront, Westlake feels distinctly Seattle: marina docks and floatplanes on Lake Union, bike lanes and bus connections on Dexter and Westlake, and quick access to the restaurants and cafés that line South Lake Union. Start with coffee near the water, meet friends for seafood at Duke’s or The White Swan, then wander toward Lake Union Park for lawn space, historic boats, and MOHAI’s local stories. When you want a bigger-city day, downtown, Seattle Center, Queen Anne, and Fremont are all within an easy hop—yet home still returns you to the calmer west edge of the lake. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how the neighborhood connects from your front door.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that make the lake part of your routine.</strong> At One Lakefront, your day can move from a yoga session to a rooftop dinner, from the fire pit to a reservation-only kayak or paddle board without leaving home base. Two rooftop terraces frame Lake Union with outdoor kitchens, grills, dining space, TVs, and lounge seating, while The Boardroom adds a vintage-inspired setting with a pool table, liquor lockers, and a large-screen TV.</p><p>Inside, thoughtful details keep everyday living polished and practical: quartz countertops, stainless steel appliances, soft-close cabinetry, custom California Closets systems, hard-surface flooring, full-size laundry, and smart-speaker-compatible electric blinds. CAT-6 wiring, package lockers, bike storage, pet parks, and indoor access to both Westlake and Dexter add convenience where it counts. See more in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenity spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Ready for Lake Union living?</strong> Start your application online for One Lakefront and move toward a home with waterfront energy, polished finishes, and city-connected convenience on Westlake’s edge. Choose the layout that fits your next chapter, then apply with confidence.</p>",
  "property_contactus_blurb": "<p><strong>Questions about One Lakefront?</strong><br>Our leasing team is here to help with availability, floor plans, directions, and what to expect from life on Lake Union’s Westlake edge. Reach out today and let us help you connect home, lake, and city.</p>",
  "property_faqs_blurb": "<p><strong>Questions before you make the lakefront move?</strong> Find quick answers about One Lakefront’s community, leasing details, amenities, and everyday living on Lake Union’s Westlake edge. If you need more information, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you like to live at One Lakefront.</strong> Choose from polished one-bedroom homes, den and loft options, two-bedroom layouts with one or two baths, and a spacious three-bedroom plan—all designed to make every inch feel intentional in Westlake. Open living areas, hard-surface flooring, full-size laundry, stainless steel appliances, quartz countertops, soft-close cabinetry, and custom California Closets systems create a clean, streamlined backdrop from move-in day.</p><p>Compare available floor plan cards to see pricing, availability, and the details that matter most: extra room to spread out, a second bath, select high ceilings, or a private patio or balcony. When a plan stands out, explore the <a href=\"/amenities\">apartment features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see the space in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the view before you visit.</strong> Browse One Lakefront’s photo gallery for a closer look at crisp apartment interiors, glassy lounge spaces, and rooftop scenes framed by Lake Union. You’ll see kitchens with quartz counters and stainless steel appliances, living areas finished with clean hard-surface flooring, and select balconies that bring the outlook closer.</p><p>Follow the images from the outdoor courtyard to the fireplace pavilion, then up to rooftop terraces with grills, lounge seating, and open-air dining. The Boardroom adds a moodier moment with vintage-inspired seating and a pool table, while the fitness center and water-ready gear hint at an active Westlake setting. Like what you see? Explore more <a href=\"/amenities\">amenity details</a>, compare <a href=\"/floor-plans\">available layouts</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Map your Lake Union connection.</strong> Explore available apartments at One Lakefront, then use the interactive map to trace the Westlake edge, waterfront paths, skyline views, and nearby city spots that keep lake and Seattle close.</p>",
  "property_pets_blurb": "<p><strong>Bring the leash, the carrier, and the lake-day routine.</strong> At One Lakefront, pets fit naturally into home with on-site pet parks, hard-surface flooring for easy cleanup, and layouts that leave room for beds, bowls, and sunny window-watching. Step outside for quick breaks without turning it into a production, or head toward the Lake Union loop for longer on-leash walks when the day calls for fresh air.</p><p>Back at the building, you can wind down on a rooftop terrace, pass through the outdoor courtyard, or settle into a home with full-size laundry and polished finishes that keep pet life feeling simple. See more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to picture your routine here.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Lake Union life.</strong> If rooftop water views, polished apartment finishes, and easy connections between home, lake, and city are what make One Lakefront stand out, invite a friend to experience it too. Send a referral and help them find their place on Westlake’s waterfront edge.</p>",
  "property_residentaccess_blurb": "<p><strong>Waterfront access, everyday ease.</strong> Log in to manage rent payments, submit maintenance requests, and keep your One Lakefront account current—all from the Lake Union home base that connects daily living with water, skyline, and city energy.</p>",
  "property_reviews_blurb": "<p><strong>Hear it from the people who call One Lakefront home.</strong> Residents consistently point to responsive service, a smooth leasing experience, and a building that feels cared for day after day.</p><p>Reviews highlight the “top notch” team, quick maintenance support, quiet apartments, and polished common spaces with standout Lake Union views. Many also mention how easy it is to settle in here, whether you are touring, moving in, or asking a quick question after arrival. If you are comparing apartments in Westlake, these firsthand stories offer a clear look at what daily life at One Lakefront is like.</p>",
  "property_created_at": "1792525543302",
  "property_scheduletour_blurb": "<p><strong>See Lake Union living up close.</strong> Tour One Lakefront’s Westlake-edge homes, rooftop water views, polished interiors, and everyday spaces designed around lake-and-city access. Schedule your visit today and picture your next Seattle backdrop in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon. In the meantime, picture life on Lake Union’s Westlake edge, with skyline views, waterfront energy, polished apartment finishes, and easy connections between home, lake, and city at One Lakefront.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. One Lakefront",
  "property_seo_title_home": "One Lakefront |  Apartments in Seattle, WA",
  "property_seo_description_home": "Discover modern living at One Lakefront, Seattle! Enjoy rooftop terraces, a top fitness center, and pet-friendly amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Seattle, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at One Lakefront in Seattle, WA! Discover unique one, two, and three-bedroom floor plans designed for comfort and style. Browse today!",
  "property_seo_title_amenities": "Amenities | Seattle, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury at One Lakefront in Seattle! Enjoy stunning views, modern amenities, pet-friendly spaces, and a vibrant community that feels like home.",
  "property_seo_title_gallery": "Gallery | Apartments in Seattle, WA",
  "property_seo_description_gallery": "Discover stunning views and stylish amenities at One Lakefront. Embrace vibrant Seattle living—your perfect home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | One Lakefront Apartments",
  "property_seo_description_virtualtours": "Experience the charm of One Lakefront in Seattle. Take a virtual tour of our stunning one, two, and three-bedroom apartments—your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | One Lakefront Apartments",
  "property_seo_description_interactivemap": "Find your future home at One Lakefront, where stunning lake views meet modern amenities. Use our interactive map to explore available apartments today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Seattle, WA",
  "property_seo_description_neighborhood": "Experience Seattle at One Lakefront! Discover trendy spots, nature trails, and local favorites just steps from your door. Your vibrant life awaits!",
  "property_seo_title_contact": "Contact Us | One Lakefront",
  "property_seo_description_contact": "Connect with the One Lakefront leasing team in Seattle, WA, to learn about our spacious one, two, and three-bedroom apartments tailored for your lifestyle.",
  "property_seo_title_faqs": "FAQs | Apartments in Seattle, WA",
  "property_seo_description_faqs": "Get answers to your burning questions about One Lakefront in Seattle! From rooftop views to pet-friendliness, discover all you need to know right here.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Seattle, WA",
  "property_seo_description_reviews": "Experience life at One Lakefront in Seattle! Check out resident reviews highlighting stunning views, top amenities, and a vibrant community atmosphere.",
  "property_seo_title_applynow": "Apply Now | Apartments in Seattle, WA",
  "property_seo_description_applynow": "Experience luxury at One Lakefront, Seattle! Enjoy rooftop terraces, a top fitness center, and pet-friendly amenities. Your dream home awaits!",
  "property_seo_title_residentaccess": "Resident Access | One Lakefront",
  "property_seo_description_residentaccess": "Stay connected at One Lakefront! Log in to your resident portal for easy rent payments, maintenance requests, and community updates—all at your fingertips.",
  "property_seo_title_referafriend": "Refer A Friend | One Lakefront",
  "property_seo_description_referafriend": "Refer a friend to One Lakefront in Seattle and cultivate a vibrant community. Great friends make the best neighbors—share the joy of lakeside living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | One Lakefront",
  "property_seo_description_scheduletour": "Experience lakeside living at One Lakefront in Seattle. Schedule your tour today and explore your future home surrounded by vibrant city life and serene views!",
  "property_seo_title_privacy": "Privacy Policy | One Lakefront",
  "property_seo_description_privacy": "Your privacy matters at One Lakefront in Seattle. Review our policy to understand how we protect your information while you enjoy lakeside living.",
  "property_seo_title_accessibility": "Website Accessibility | One Lakefront",
  "property_seo_description_accessibility": "At One Lakefront in Seattle, we prioritize accessibility for all. Join us in ensuring an inclusive community where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | One Lakefront",
  "property_seo_description_sitemap": "Navigate your way to home sweet home at One Lakefront! Check out our sitemap for all your Seattle apartment needs—find your perfect space today!",
  "property_seo_title_thankyou": "Thank You | One Lakefront",
  "property_seo_description_thankyou": "Thank you for reaching out to One Lakefront! A team member will connect with you soon. Exciting lakeside living in Seattle awaits! Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Seattle, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1792525543300",
  "amenities": [
    {
      "id": "ec_f9bfcac04f8821d10e150187",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007402",
      "title": "State of-the-Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-e5ec-754c-af34-4212ff17d669.webp",
      "amenity_image_media": {
        "alt_text": "Gym with cardio machines and free weights",
        "public_id": "01a15af3-e5ec-754c-af34-4212ff17d669",
        "storage_key": "property/6767906449167762/01a15af3-e5ec-754c-af34-4212ff17d669.webp",
        "width": 1038,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e3d4afee846175739585746",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "111843422",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2cb66900538d8b6f7f6d0bb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007400",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac3a6413d8c9343504ec5db5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007406",
      "title": "Reserved Garage Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c0a04db7c085988ff4a8a85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007401",
      "title": "Roof Top Terrace with Sweeping City & Puget Sound Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-e5dd-77ef-bb78-f843e3720706.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop terrace with lounge chairs, dining tables, and grills at sunset, offering city and water views.",
        "public_id": "01a15af3-e5dd-77ef-bb78-f843e3720706",
        "storage_key": "property/6767906449167762/01a15af3-e5dd-77ef-bb78-f843e3720706.webp",
        "width": 1038,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9afaa15dcdbba59485f3a52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007394",
      "title": "Gas firepit and grilling area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-e4d9-73bf-a2fb-76f3b4806a45.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop lounge with seating, grills, and city views at sunset.",
        "public_id": "01a15af3-e4d9-73bf-a2fb-76f3b4806a45",
        "storage_key": "property/6767906449167762/01a15af3-e4d9-73bf-a2fb-76f3b4806a45.webp",
        "width": 1038,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc20c3f5d2e230a87e0499b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007395",
      "title": "Billiards Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-e5d6-74fb-9519-1b1a25e66e4a.webp",
      "amenity_image_media": {
        "alt_text": "Game room with pool table, foosball table, and kitchenette.",
        "public_id": "01a15af3-e5d6-74fb-9519-1b1a25e66e4a",
        "storage_key": "property/6767906449167762/01a15af3-e5d6-74fb-9519-1b1a25e66e4a.webp",
        "width": 1038,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e832f999d6f8b2bf14e18c5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007408",
      "title": "Covered Sky lounge with big screen TV",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-e63b-7448-9934-29c0357b5946.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop terrace with lounge chairs, tables, and city skyline view.",
        "public_id": "01a15af3-e63b-7448-9934-29c0357b5946",
        "storage_key": "property/6767906449167762/01a15af3-e63b-7448-9934-29c0357b5946.webp",
        "width": 1037,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_950d9541d6e50ae21d5d8f57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007399",
      "title": "Additional Storage On-Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-f5f3-7428-8d79-95293277dcb7.webp",
      "amenity_image_media": {
        "alt_text": "Indoor storage units with orange roll-up doors and wire mesh above.",
        "public_id": "01a15af3-f5f3-7428-8d79-95293277dcb7",
        "storage_key": "property/6767906449167762/01a15af3-f5f3-7428-8d79-95293277dcb7.webp",
        "width": 1146,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c2ff014ed4b6ae7e67e4852",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "114403491",
      "title": "EV Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-f579-716a-9aef-bc438081cab7.webp",
      "amenity_image_media": {
        "alt_text": "Electric vehicle charging stations in a parking garage.",
        "public_id": "01a15af3-f579-716a-9aef-bc438081cab7",
        "storage_key": "property/6767906449167762/01a15af3-f579-716a-9aef-bc438081cab7.webp",
        "width": 897,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ba25cda5a087a4e345176ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "111843423",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5da79ea25add225ced5e43a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007405",
      "title": "Easy Access to I5, 99, 520 & I90",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_584f41a4f65ef8b55579fb83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007407",
      "title": "Valet Dry Cleaning",
      "amount": "false",
      "description": "through Bakkers Fine Dry Cleaning",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d3bb9f45f2df6dcf2871a61d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007409",
      "title": "Free Bike Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1493bd9daff52aa284ec816",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007411",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58e8e4c6340a2166e8bf1f1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007412",
      "title": "Wi-Fi Hot Spots",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_25201cbef6ebb69c5d959358",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007410",
      "title": "Accepts Electronic Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80b5958d23ce265d10487a86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "124799694",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f8e3a39412ab3d3d9090c30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007425",
      "title": "Full Size Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9bf20909184dba5934f13433",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007419",
      "title": "Floating Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4416c74917cef71c1a2a8554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007420",
      "title": "Air Conditioner Hookups*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dde1bccac0a0b60dca8d18bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007424",
      "title": "Private Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c36021c10140b448d870eae2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007440",
      "title": "Walk-In Closet*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc5a45c4d78ba9affa1904e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007416",
      "title": "Cable or Satellite",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2622cbd0d6e5c6cc3c740ff9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007422",
      "title": "City, Mountain & Water Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa97d1412ed537bf9bf1d191",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007413",
      "title": "Stainless Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-f51d-741d-8c36-61e576364e00.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinetry.",
        "public_id": "01a15af3-f51d-741d-8c36-61e576364e00",
        "storage_key": "property/6767906449167762/01a15af3-f51d-741d-8c36-61e576364e00.webp",
        "width": 1038,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1bb00b730608addbe42c3036",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007415",
      "title": "Breakfast Bar*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-f36d-767a-b84f-01c22bba0763.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen and living area with city view.",
        "public_id": "01a15af3-f36d-767a-b84f-01c22bba0763",
        "storage_key": "property/6767906449167762/01a15af3-f36d-767a-b84f-01c22bba0763.webp",
        "width": 1050,
        "height": 692
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c79c52bebeaeaa7cd21d3669",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007439",
      "title": "Glass Top Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96345f2ff11189fdd7aab5c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007423",
      "title": "Undermount Sinks",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7b5d4e6c697cbbb25e6602f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007418",
      "title": "Key Fob Entry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce56a424f68806d1b3f7de96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "112007428",
      "title": "Ample Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c614358bc61c28a7e36d517",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "127863725",
      "title": "Accessible",
      "amount": "false",
      "description": "Accessible",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f9f89ae1aefce29f9cc0bab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "127863726",
      "title": "Corner Unit",
      "amount": "false",
      "description": "Corner Unit",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e5b8503f474186829a6b3ce6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "128006114",
      "title": "2nd Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c05fb313b212b51d0258d189",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "128006094",
      "title": "3rd Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c53794de7c064069e512be9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "128006095",
      "title": "4th Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b6cd56746ca69a7f6114f54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "127863733",
      "title": "5th Floor",
      "amount": "false",
      "description": "Floor Level 5",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4bc282204958d714a790f948",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "127863734",
      "title": "6th Floor",
      "amount": "false",
      "description": "Floor Level 6",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_178cc57a534d17bbfb9c94e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "127863735",
      "title": "7th Floor",
      "amount": "false",
      "description": "Floor Level 7",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2a6e7faa0283bad94d54fa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "127863737",
      "title": "8th Floor",
      "amount": "false",
      "description": "Floor Level 8",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb2bdf0c962ac1a8e3faf5af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "yardi",
      "external_id": "127863775",
      "title": "Walk-in Closet",
      "amount": "false",
      "description": "Walk-in Closet",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_3d91e8fca1d0d65d231874e2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af3-c9b4-72df-84c5-332b1209df53.webp",
      "image_media": {
        "alt_text": "Building exterior with balconies and signage '206 BELL'",
        "public_id": "01a15af3-c9b4-72df-84c5-332b1209df53",
        "storage_key": "property/6767906449167762/01a15af3-c9b4-72df-84c5-332b1209df53.webp",
        "width": 2560,
        "height": 1468
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring multiple balconies and striking architectural details. Includes prominent '206 BELL' signage.",
      "link": "false",
      "alt_text": "Building exterior with balconies and signage '206 BELL'",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Weidner-Washington-206-Bell_Exterior_Building-Sign.jpg"
    },
    {
      "id": "ec_bdc425e385b175f644668d10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-089d-77c9-9622-92386d2c3307.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with red, gray, and yellow facade elements.",
        "public_id": "01a15af4-089d-77c9-9622-92386d2c3307",
        "storage_key": "property/6767906449167762/01a15af4-089d-77c9-9622-92386d2c3307.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "A striking modern apartment building showcasing a vibrant facade with contrasting red, gray, and yellow panels. Features large windows and balconies, set against a clear blue sky.",
      "link": "false",
      "alt_text": "Exterior view of a modern apartment building with red, gray, and yellow facade elements.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Weidner-Washington-206-Bell_Exterior_Building.jpg"
    },
    {
      "id": "ec_6e632e26e2eee2ff3196647a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-07f7-76ef-84dc-0c29d64305f8.webp",
      "image_media": {
        "alt_text": "Rooftop patio with grills, seating, and water views at sunset.",
        "public_id": "01a15af4-07f7-76ef-84dc-0c29d64305f8",
        "storage_key": "property/6767906449167762/01a15af4-07f7-76ef-84dc-0c29d64305f8.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy stunning sunset views from our rooftop patio, complete with grilling stations and comfortable seating areas.",
      "link": "false",
      "alt_text": "Rooftop patio with grills, seating, and water views at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Amenity_Exterior_Rooftop-Lounge_2.jpg"
    },
    {
      "id": "ec_76b7e2bfbfeff6a52c9ae404",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-0a32-70c7-8861-659b97ae855e.webp",
      "image_media": {
        "alt_text": "Rooftop lounge with seating, grills, and city views at sunset.",
        "public_id": "01a15af4-0a32-70c7-8861-659b97ae855e",
        "storage_key": "property/6767906449167762/01a15af4-0a32-70c7-8861-659b97ae855e.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Community",
      "description": "Enjoy stunning city views from the rooftop lounge, complete with comfortable seating, grilling stations, and ambient lighting.",
      "link": "false",
      "alt_text": "Rooftop lounge with seating, grills, and city views at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Amenity_Exterior_Rooftop-Lounge_1.jpg"
    },
    {
      "id": "ec_41be0b0df5a143005d6eed57",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-0858-7449-93c0-672e1f714a9c.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations in a parking garage.",
        "public_id": "01a15af4-0858-7449-93c0-672e1f714a9c",
        "storage_key": "property/6767906449167762/01a15af4-0858-7449-93c0-672e1f714a9c.webp",
        "width": 3072,
        "height": 2294
      },
      "title": "Community",
      "description": "Convenient electric vehicle charging stations available in the parking garage for residents.",
      "link": "false",
      "alt_text": "Electric vehicle charging stations in a parking garage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Amenity_EV-Charging.jpg"
    },
    {
      "id": "ec_b985926e7c6c8df0f7b4f446",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-09df-70bd-bcb1-415d74010449.webp",
      "image_media": {
        "alt_text": "Storage units with orange roll-up doors and metal security cages.",
        "public_id": "01a15af4-09df-70bd-bcb1-415d74010449",
        "storage_key": "property/6767906449167762/01a15af4-09df-70bd-bcb1-415d74010449.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Other",
      "description": "Secure your belongings in our convenient on-site storage units. Featuring durable orange roll-up doors and metal security cages for added peace of mind.",
      "link": "false",
      "alt_text": "Storage units with orange roll-up doors and metal security cages.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Amenity_Storage.jpg"
    },
    {
      "id": "ec_1f215f0267807decfd7b939a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-1577-7401-a530-61ce537bb9e6.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and exercise balls.",
        "public_id": "01a15af4-1577-7401-a530-61ce537bb9e6",
        "storage_key": "property/6767906449167762/01a15af4-1577-7401-a530-61ce537bb9e6.webp",
        "width": 1038,
        "height": 692
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide range of cardio and strength training equipment.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, elliptical machines, weight machines, and exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_10_PhotoGallery.jpg"
    },
    {
      "id": "ec_b899aba1e13001d5d48c5305",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-1573-741d-a06d-328088d74e3e.webp",
      "image_media": {
        "alt_text": "Game room with pool table, foosball, and seating.",
        "public_id": "01a15af4-1573-741d-a06d-328088d74e3e",
        "storage_key": "property/6767906449167762/01a15af4-1573-741d-a06d-328088d74e3e.webp",
        "width": 1038,
        "height": 692
      },
      "title": "Community",
      "description": "Enjoy hours of fun in our resident game room, featuring a pool table and foosball.",
      "link": "false",
      "alt_text": "Game room with pool table, foosball, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_04_PhotoGallery.jpg"
    },
    {
      "id": "ec_a732ed4baca34bada12ca231",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-1726-73a9-8aa3-36414e5a1e8b.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen bed, walk-in closet, and stylish decor.",
        "public_id": "01a15af4-1726-73a9-8aa3-36414e5a1e8b",
        "storage_key": "property/6767906449167762/01a15af4-1726-73a9-8aa3-36414e5a1e8b.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our spacious bedrooms, featuring a plush queen-size bed, ample closet space, and contemporary design elements.",
      "link": "false",
      "alt_text": "Modern bedroom with a queen bed, walk-in closet, and stylish decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_03_PhotoGallery(1).jpg"
    },
    {
      "id": "ec_6eb6e7149c20d8a0bd611ba0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-187d-751c-b9a9-df9e1469ea95.webp",
      "image_media": {
        "alt_text": "Modern living room with blue couch, TV, and framed soccer jersey.",
        "public_id": "01a15af4-187d-751c-b9a9-df9e1469ea95",
        "storage_key": "property/6767906449167762/01a15af4-187d-751c-b9a9-df9e1469ea95.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable blue sofa, a modern entertainment center with a flat-screen TV, and a framed Seattle Sounders FC jersey, perfect for game day.",
      "link": "false",
      "alt_text": "Modern living room with blue couch, TV, and framed soccer jersey.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Livingroom_1.jpg"
    },
    {
      "id": "ec_409bbef34dc7990b1b0f3734",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-1997-728a-8ba3-3b5a3c61a61d.webp",
      "image_media": {
        "alt_text": "Modern apartment living room and kitchen area with blue sofa, dining table, and stainless steel appliances.",
        "public_id": "01a15af4-1997-728a-8ba3-3b5a3c61a61d",
        "storage_key": "property/6767906449167762/01a15af4-1997-728a-8ba3-3b5a3c61a61d.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Explore this stylish apartment featuring an open-concept living and kitchen area, perfect for entertaining. Enjoy modern finishes and a comfortable living space.",
      "link": "false",
      "alt_text": "Modern apartment living room and kitchen area with blue sofa, dining table, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_13_PhotoGallery(1).jpg"
    },
    {
      "id": "ec_e7c832832baedebc4667b55d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-2219-727c-883b-914b947d8e4e.webp",
      "image_media": {
        "alt_text": "Kitchen in an apartment with stainless steel appliances, light wood cabinets, and granite countertops.",
        "public_id": "01a15af4-2219-727c-883b-914b947d8e4e",
        "storage_key": "property/6767906449167762/01a15af4-2219-727c-883b-914b947d8e4e.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring stainless steel appliances, ample cabinet storage, and granite countertops, perfect for any home chef.",
      "link": "false",
      "alt_text": "Kitchen in an apartment with stainless steel appliances, light wood cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Kitchen.jpg"
    },
    {
      "id": "ec_15ee79314cee5a5a9ad98857",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-22cc-7200-8ec6-22b035e463fa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
        "public_id": "01a15af4-22cc-7200-8ec6-22b035e463fa",
        "storage_key": "property/6767906449167762/01a15af4-22cc-7200-8ec6-22b035e463fa.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Sleek and modern kitchen featuring dark wood cabinetry, granite countertops, and stainless steel appliances, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and hardwood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_12_PhotoGallery(1).jpg"
    },
    {
      "id": "ec_26111891f0b47ab67b5dfc3c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-244f-7288-9d62-e2c243eb95e2.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with large windows and balcony overlooking city skyline.",
        "public_id": "01a15af4-244f-7288-9d62-e2c243eb95e2",
        "storage_key": "property/6767906449167762/01a15af4-244f-7288-9d62-e2c243eb95e2.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious and bright apartment living area with floor-to-ceiling windows offering stunning city views and access to a private balcony.",
      "link": "false",
      "alt_text": "Empty apartment living room with large windows and balcony overlooking city skyline.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Livingroom_2.jpg"
    },
    {
      "id": "ec_b98045e6955961549dec665a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-25d2-707b-addb-b58e2beef35b.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with large windows and city views.",
        "public_id": "01a15af4-25d2-707b-addb-b58e2beef35b",
        "storage_key": "property/6767906449167762/01a15af4-25d2-707b-addb-b58e2beef35b.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this modern apartment featuring a fully equipped kitchen and a stylish living area, perfect for relaxing and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen and living area with large windows and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_01_PhotoGallery(2).jpg"
    },
    {
      "id": "ec_a8fe1552df9427de6cf7f906",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-27ea-734c-a7c5-86114c933f52.webp",
      "image_media": {
        "alt_text": "Bedroom with queen bed, nightstands, and walk-in closets.",
        "public_id": "01a15af4-27ea-734c-a7c5-86114c933f52",
        "storage_key": "property/6767906449167762/01a15af4-27ea-734c-a7c5-86114c933f52.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a queen-size bed, modern decor, and ample storage with dual walk-in closets.",
      "link": "false",
      "alt_text": "Bedroom with queen bed, nightstands, and walk-in closets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/206-Bell_Bedroom.jpg"
    },
    {
      "id": "ec_ce8133049c9dd7aa259ce994",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15af4-3006-726d-8aa1-550259248105.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinetry.",
        "public_id": "01a15af4-3006-726d-8aa1-550259248105",
        "storage_key": "property/6767906449167762/01a15af4-3006-726d-8aa1-550259248105.webp",
        "width": 2400,
        "height": 1792
      },
      "title": "Apartment",
      "description": "Bright and airy apartment kitchen featuring stainless steel appliances, granite countertops, and ample storage. Enjoy cooking with a view!",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and wood cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/p1622692_206Bell_02_PhotoGallery(2).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_03a21b4fd1eeaf4d21df512c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "re:public",
      "poi_type": "Restaurants",
      "poi_address": "429 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Happening spot crafting farm-to-table Pacific Northwest dishes in a modern, exposed-brick space.",
      "poi_long_description": "Happening spot crafting farm-to-table Pacific Northwest dishes in a modern, exposed-brick space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-834d-77e1-8b08-b8f04f47cdae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-834d-77e1-8b08-b8f04f47cdae",
        "storage_key": "property/6767906449167762/01a15adb-834d-77e1-8b08-b8f04f47cdae.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.republicseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1735863275466340839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "republic",
      "poi_latitude": "47.6229107",
      "poi_longitude": "-122.3386494",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-222-9190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ7vyKjgVkFQR5znRuHMGFxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_821576191136676b36e8e9cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "kakao",
      "poi_type": "Restaurants",
      "poi_address": "415 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Airy, modern cafe selling specialty coffee drinks, beans & chocolates, with table seating & WiFi.",
      "poi_long_description": "Airy, modern cafe selling specialty coffee drinks, beans & chocolates, with table seating & WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-8289-7217-83a8-fda07795f6fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-8289-7217-83a8-fda07795f6fe",
        "storage_key": "property/6767906449167762/01a15adb-8289-7217-83a8-fda07795f6fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kakaoseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3163910068413480605&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kakao",
      "poi_latitude": "47.622550999999994",
      "poi_longitude": "-122.338855",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0ad2-713d-85a2-0e1344a34ff6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0ad2-713d-85a2-0e1344a34ff6",
        "storage_key": "property/6767906449167762/01a15adc-0ad2-713d-85a2-0e1344a34ff6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ9T_ghTcVkFQRnT4RsXF36Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_432a960e0209d57fb10bd8c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "The Berliner Döner Kebab",
      "poi_type": "Restaurants",
      "poi_address": "428 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Easygoing counter serve specializing in German-style Turkish sandwiches, with vegetarian options.",
      "poi_long_description": "Easygoing counter serve specializing in German-style Turkish sandwiches, with vegetarian options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-9cdc-7119-b736-b09f09556327.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-9cdc-7119-b736-b09f09556327",
        "storage_key": "property/6767906449167762/01a15adb-9cdc-7119-b736-b09f09556327.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.toasttab.com/the-berliner-doner-kebab-428-westlake-ave-n?utm_source=google&utm_medium=organic&utm_campaign=gmb-oo-web",
      "poi_directions_map_url": "https://maps.google.com/?cid=718232246654827628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-berliner-dner-kebab",
      "poi_latitude": "47.6226649",
      "poi_longitude": "-122.3381333",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-623-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG0hRgTcVkFQRbHwXSGys9wk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "turkish_restaurant"
    },
    {
      "id": "ec_7519b035d5fe96129e79f97e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Flying Fish Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "300 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "The seasonal menu changes daily at this seafood eatery housed in a cavernous glass-walled space.",
      "poi_long_description": "The seasonal menu changes daily at this seafood eatery housed in a cavernous glass-walled space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-82fc-77bb-b26e-29e7c95fb01f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-82fc-77bb-b26e-29e7c95fb01f",
        "storage_key": "property/6767906449167762/01a15adb-82fc-77bb-b26e-29e7c95fb01f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17591327398116585261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flying-fish-restaurant",
      "poi_latitude": "47.6210858",
      "poi_longitude": "-122.3381935",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-728-8595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX2stxjcVkFQRLe9V1BDzIPQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_52131e04c09a5518a9befa44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Duke's Seafood South Lake Union",
      "poi_type": "Restaurants",
      "poi_address": "1111 Fairview Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Local chain serving market-fresh seafood, grass-fed burgers & cocktails in informal surroundings.",
      "poi_long_description": "Local chain serving market-fresh seafood, grass-fed burgers & cocktails in informal surroundings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-863c-7301-a390-4c1d77815809.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-863c-7301-a390-4c1d77815809",
        "storage_key": "property/6767906449167762/01a15adb-863c-7301-a390-4c1d77815809.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://dukesseafood.com/locations/lake-union/?utm_source=google&utm_medium=organic&utm_campaign=gbp_website&utm_content=lake-union",
      "poi_directions_map_url": "https://maps.google.com/?cid=6726468777202902804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dukes-seafood-south-lake-union",
      "poi_latitude": "47.6297136",
      "poi_longitude": "-122.3304263",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-382-9963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMY6CBjsVkFQRFGfv6bY3WV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_04d64fbc1390c50161d08506",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Portage Bay Cafe - South Lake Union",
      "poi_type": "Restaurants",
      "poi_address": "391 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Bustling, bright cafe serving local, organic & seasonal breakfast, brunch & lunch dishes.",
      "poi_long_description": "Bustling, bright cafe serving local, organic & seasonal breakfast, brunch & lunch dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-803e-753d-9cc8-7d0c0a2a7b87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-803e-753d-9cc8-7d0c0a2a7b87",
        "storage_key": "property/6767906449167762/01a15adb-803e-753d-9cc8-7d0c0a2a7b87.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portagebaycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13067652949942653666&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portage-bay-cafe---south-lake-union",
      "poi_latitude": "47.621843",
      "poi_longitude": "-122.337419",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-462-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ZC5oTcVkFQR4tJqYR-hWbU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "ec_d157c9c4c1f53c65bac8df7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Ba Bar South Lake Union",
      "poi_type": "Restaurants",
      "poi_address": "500 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Contemporary, wood-paneled restaurant and bar serving Vietnamese street-eats and cocktails.",
      "poi_long_description": "Contemporary, wood-paneled restaurant and bar serving Vietnamese street-eats and cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-8787-74e7-9a3a-e7189cf02bfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-8787-74e7-9a3a-e7189cf02bfb",
        "storage_key": "property/6767906449167762/01a15adb-8787-74e7-9a3a-e7189cf02bfb.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://babarseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18107570801545836809&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ba-bar-south-lake-union",
      "poi_latitude": "47.6233692",
      "poi_longitude": "-122.3369207",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-588-1022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-eTKYTcVkFQRCflfu7QDS_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "ec_27140c107a3cd5a2fedb2252",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Paju",
      "poi_type": "Restaurants",
      "poi_address": "513 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Snug, simple restaurant offering contemporary, inventive takes on traditional Korean cuisine.",
      "poi_long_description": "Snug, simple restaurant offering contemporary, inventive takes on traditional Korean cuisine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-835c-71ac-a09c-2f508ac09aab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-835c-71ac-a09c-2f508ac09aab",
        "storage_key": "property/6767906449167762/01a15adb-835c-71ac-a09c-2f508ac09aab.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.pajurestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7985221622297603729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paju",
      "poi_latitude": "47.62383",
      "poi_longitude": "-122.3386788",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-829-8215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXcSoyoEVkFQRkS7RCcI00W4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "ec_5ce525fa61bdb00ae4a4030a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Caffe Ladro - South Lake Union Fairview",
      "poi_type": "Restaurants",
      "poi_address": "400 Fairview Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Contemporary local coffeehouse chain featuring sustainable beans, plus pastries & other baked goods.",
      "poi_long_description": "Contemporary local coffeehouse chain featuring sustainable beans, plus pastries & other baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-83b4-74cd-90af-f5739fed7cde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-83b4-74cd-90af-f5739fed7cde",
        "storage_key": "property/6767906449167762/01a15adb-83b4-74cd-90af-f5739fed7cde.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.caffeladro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11352058730114448826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caffe-ladro---south-lake-union-fairview",
      "poi_latitude": "47.6222074",
      "poi_longitude": "-122.3339903",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-906-9334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0ad2-713d-85a2-0e1344a34ff6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0ad2-713d-85a2-0e1344a34ff6",
        "storage_key": "property/6767906449167762/01a15adc-0ad2-713d-85a2-0e1344a34ff6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJVaEoOzcVkFQRuv3X7USdip0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_899b96088626e3dfa40d7c63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Café Hagen Modern European Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1252 Thomas St, Seattle, WA 98109, USA",
      "poi_short_description": "Stylish, window-filled space serving specialty coffee drinks & Scandinavian brunch/lunch fare.",
      "poi_long_description": "Stylish, window-filled space serving specialty coffee drinks & Scandinavian brunch/lunch fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-7ea1-7571-9520-72ac515df0e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-7ea1-7571-9520-72ac515df0e2",
        "storage_key": "property/6767906449167762/01a15adb-7ea1-7571-9520-72ac515df0e2.webp",
        "width": 485,
        "height": 606
      },
      "poi_business_url": "http://cafehagen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2083651955621658302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "caf-hagen-modern-european-cafe",
      "poi_latitude": "47.6210768",
      "poi_longitude": "-122.331414",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-913-2847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ30hA4soVkFQRvn5g-mme6hw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "european_restaurant"
    },
    {
      "id": "ec_e06357ee2d4774680afe801a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Hummingbird Sushi",
      "poi_type": "Restaurants",
      "poi_address": "11 Mercer St, Seattle, WA 98109, USA",
      "poi_short_description": "Modern Japanese Omakase venue featuring creative, seasonal seafood dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-8bd6-76ea-8347-309597545565.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-8bd6-76ea-8347-309597545565",
        "storage_key": "property/6767906449167762/01a15adb-8bd6-76ea-8347-309597545565.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.hummingbirdsushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17320479739718490957&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hummingbird-sushi",
      "poi_latitude": "47.6244727",
      "poi_longitude": "-122.3561475",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-295-0070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82HkJwAVkFQRTVtFMY60XvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "ec_af2e93b1e16cd1cda2a3eecf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Westward",
      "poi_type": "Restaurants",
      "poi_address": "2501 N Northlake Way, Seattle, WA 98103, USA",
      "poi_short_description": "Mediterranean fare with seafood slant served in nautical-style digs with patio views over the lake.",
      "poi_long_description": "Mediterranean fare with seafood slant served in nautical-style digs with patio views over the lake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-8e06-7704-bbb8-95bb8f519807.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-8e06-7704-bbb8-95bb8f519807",
        "storage_key": "property/6767906449167762/01a15adb-8e06-7704-bbb8-95bb8f519807.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.westwardseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11576029611985013815&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westward",
      "poi_latitude": "47.65171960000001",
      "poi_longitude": "-122.3287866",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-552-8215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpf3ouPsUkFQRNwzFg5lRpqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "ec_357265716dbc4e242308027e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Serafina",
      "poi_type": "Restaurants",
      "poi_address": "2043 Eastlake Ave E, Seattle, WA 98102, USA",
      "poi_short_description": "Old-world Italian restaurant with a multiregional, traditional menu & a seasonal outdoor patio.",
      "poi_long_description": "Old-world Italian restaurant with a multiregional, traditional menu & a seasonal outdoor patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-8fcd-7218-84e4-ddf76e1ce674.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-8fcd-7218-84e4-ddf76e1ce674",
        "storage_key": "property/6767906449167762/01a15adb-8fcd-7218-84e4-ddf76e1ce674.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://serafinaseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17948156089395477553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "serafina",
      "poi_latitude": "47.6380822",
      "poi_longitude": "-122.3261461",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-323-0807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxV19B8VkFQRMXyusd6oFPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_91418eb1876727bee3b5c9db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "503 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-94ad-706d-baea-f38b7250a29d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-94ad-706d-baea-f38b7250a29d",
        "storage_key": "property/6767906449167762/01a15adb-94ad-706d-baea-f38b7250a29d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/seattle-wa-pharmacies/503-westlake-ave-n-seattle-wa-98109/storeid=11076?WT.mc_id=LS_GOOGLE_RX_11076",
      "poi_directions_map_url": "https://maps.google.com/?cid=7590490931773551987&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "47.6233739",
      "poi_longitude": "-122.3388013",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-505-2330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0ad2-713d-85a2-137a7190a225.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0ad2-713d-85a2-137a7190a225",
        "storage_key": "property/6767906449167762/01a15adc-0ad2-713d-85a2-137a7190a225.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKZUDj_UVkFQRc7UvS0nXVmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_096b9b6e4cf14eb5f0ea0bd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2210 Westlake Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-5236-7618-8d2a-8c22693acb41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15ad9-5236-7618-8d2a-8c22693acb41",
        "storage_key": "property/6767906449167762/01a15ad9-5236-7618-8d2a-8c22693acb41.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/westlake?utm_source=google&utm_medium=organic&utm_campaign=listings&ref_=US_TRF_ALL_UFG_WFM_FRSOC_1001768",
      "poi_directions_map_url": "https://maps.google.com/?cid=13331991485400734650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.6183573",
      "poi_longitude": "-122.3380162",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-621-9700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a912-719f-9576-c0ae0b5a42c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a912-719f-9576-c0ae0b5a42c1",
        "storage_key": "property/6767906449167762/01a15ad9-a912-719f-9576-c0ae0b5a42c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyz9g9EkVkFQRutvXu56_BLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_2e45f62022d4a756818532ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Belltown Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "2221 3rd Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Compact food store selling a broad array of grocery items, plus premade gourmet sandwiches.",
      "poi_long_description": "Compact food store selling a broad array of grocery items, plus premade gourmet sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-9e87-765c-a4bb-48350e9a1610.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-9e87-765c-a4bb-48350e9a1610",
        "storage_key": "property/6767906449167762/01a15adb-9e87-765c-a4bb-48350e9a1610.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15698169554662695837&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "belltown-grocery",
      "poi_latitude": "47.6142073",
      "poi_longitude": "-122.3444919",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-441-0220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a912-719f-9576-c0ae0b5a42c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a912-719f-9576-c0ae0b5a42c1",
        "storage_key": "property/6767906449167762/01a15ad9-a912-719f-9576-c0ae0b5a42c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_FMP0wVkFQRnaOFmQka29k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_b89114fe712bac629dab9379",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1916 Queen Anne Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-988d-74ef-8860-edb34db8d26b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-988d-74ef-8860-edb34db8d26b",
        "storage_key": "property/6767906449167762/01a15adb-988d-74ef-8860-edb34db8d26b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/seattle/135/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17564721949741482960&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.6365646",
      "poi_longitude": "-122.3566206",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-284-2546",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a912-719f-9576-c0ae0b5a42c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a912-719f-9576-c0ae0b5a42c1",
        "storage_key": "property/6767906449167762/01a15ad9-a912-719f-9576-c0ae0b5a42c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-z5HhMVkFQR0APZKI1twvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_a1144ef1f0abe34d268915a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "H Mart Downtown Seattle",
      "poi_type": "Shopping & Retail",
      "poi_address": "1601 2nd Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Asian grocery store offering fresh produce and a variety of hot ready-to-eat meals.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-9d5f-73b8-8d54-8e01d31452fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-9d5f-73b8-8d54-8e01d31452fd",
        "storage_key": "property/6767906449167762/01a15adb-9d5f-73b8-8d54-8e01d31452fd.webp",
        "width": 1280,
        "height": 1163
      },
      "poi_business_url": "http://hmartus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1924453621694210560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-mart-downtown-seattle",
      "poi_latitude": "47.61027",
      "poi_longitude": "-122.3402051",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-677-0345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a912-719f-9576-c0ae0b5a42c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a912-719f-9576-c0ae0b5a42c1",
        "storage_key": "property/6767906449167762/01a15ad9-a912-719f-9576-c0ae0b5a42c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQcALZNrkFQRACLMa18ItRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "ec_99f5ccdb9948f016fd3ecac3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1401 2nd Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-9cdc-7119-b736-adb373507584.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-9cdc-7119-b736-adb373507584",
        "storage_key": "property/6767906449167762/01a15adb-9cdc-7119-b736-adb373507584.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.target.com/sl/seattle-pike-plaza/2786",
      "poi_directions_map_url": "https://maps.google.com/?cid=2472263421707813677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "47.6086476",
      "poi_longitude": "-122.3387914",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-494-3250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a911-75eb-84ea-29c9165517d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a911-75eb-84ea-29c9165517d7",
        "storage_key": "property/6767906449167762/01a15ad9-a911-75eb-84ea-29c9165517d7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6SynALNqkFQRLQMWwns-TyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_5eb81a883898a9dae379fe27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Metropolitan Market Queen Anne (Uptown)",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 Mercer St, Seattle, WA 98109, USA",
      "poi_short_description": "Local chain outpost of upscale supermarkets with a variety of foodstuffs, plus prepared meals.",
      "poi_long_description": "Local chain outpost of upscale supermarkets with a variety of foodstuffs, plus prepared meals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-a3c3-715c-8524-1b36dc5506d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-a3c3-715c-8524-1b36dc5506d5",
        "storage_key": "property/6767906449167762/01a15adb-a3c3-715c-8524-1b36dc5506d5.webp",
        "width": 1280,
        "height": 990
      },
      "poi_business_url": "https://www.metropolitan-market.com/locations/queen-anne",
      "poi_directions_map_url": "https://maps.google.com/?cid=15107838454557967876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metropolitan-market-queen-anne-uptown",
      "poi_latitude": "47.6247988",
      "poi_longitude": "-122.3548324",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-213-0778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a912-719f-9576-c0ae0b5a42c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a912-719f-9576-c0ae0b5a42c1",
        "storage_key": "property/6767906449167762/01a15ad9-a912-719f-9576-c0ae0b5a42c1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsY2q3UMVkFQRBAbqlwfTqdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_244d90f534aac2b13b19355d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Pike Place Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "85 Pike St, Seattle, WA 98101, USA",
      "poi_short_description": "Landmark daily market with famed fish-throwing seafood vendors, produce stalls & other shops.",
      "poi_long_description": "Landmark daily market with famed fish-throwing seafood vendors, produce stalls & other shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-bfbf-735a-b022-07d316984e9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-bfbf-735a-b022-07d316984e9f",
        "storage_key": "property/6767906449167762/01a15adb-bfbf-735a-b022-07d316984e9f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.pikeplacemarket.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10660459035763804716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pike-place-market",
      "poi_latitude": "47.6094076",
      "poi_longitude": "-122.3418358",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 206-682-7453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a911-75eb-84ea-29c9165517d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a911-75eb-84ea-29c9165517d7",
        "storage_key": "property/6767906449167762/01a15ad9-a911-75eb-84ea-29c9165517d7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPcr187JrkFQRLApO8QKP8ZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "ec_101feb0193daeb323d65be5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Westlake Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "400 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "4-story, glass-enclosed retail center for shopping & dining with a food court.",
      "poi_long_description": "4-story, glass-enclosed retail center for shopping & dining with a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-a16a-723b-8851-cd2ea8eabea5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-a16a-723b-8851-cd2ea8eabea5",
        "storage_key": "property/6767906449167762/01a15adb-a16a-723b-8851-cd2ea8eabea5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.westlakecenter.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=878541090116204128&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westlake-center",
      "poi_latitude": "47.6120485",
      "poi_longitude": "-122.3374325",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-467-1600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a911-75eb-84ea-29c9165517d7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a911-75eb-84ea-29c9165517d7",
        "storage_key": "property/6767906449167762/01a15ad9-a911-75eb-84ea-29c9165517d7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5YbCpbRqkFQRYPb1fHc0MQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_283790e32022178ef08e7f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "John Hay Elementary School",
      "poi_type": "Education",
      "poi_address": "201 Garfield St, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-a45b-706a-b13c-b596276872aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-a45b-706a-b13c-b596276872aa",
        "storage_key": "property/6767906449167762/01a15adb-a45b-706a-b13c-b596276872aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hayes.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5874759900747356384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-hay-elementary-school",
      "poi_latitude": "47.6328489",
      "poi_longitude": "-122.3522135",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-252-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ32PP-hQVkFQR4FjBAAFXh1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_17034e29fa6ae4f7516fc218",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Queen Anne Elementary School",
      "poi_type": "Education",
      "poi_address": "2100 4th Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-b37c-7746-a35a-a137a43fbe72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-b37c-7746-a35a-a137a43fbe72",
        "storage_key": "property/6767906449167762/01a15adb-b37c-7746-a35a-a137a43fbe72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://queenannees.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5903609249051925195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "queen-anne-elementary-school",
      "poi_latitude": "47.6374085",
      "poi_longitude": "-122.3493473",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-252-2480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJaztWtlYUkFQRy1pzVlXV7VE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_7abbe68ba15fa8a94864ff45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "McClure Middle School",
      "poi_type": "Education",
      "poi_address": "1915 1st Ave W, Seattle, WA 98119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-abcd-73e8-b7d4-55bd1147d676.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-abcd-73e8-b7d4-55bd1147d676",
        "storage_key": "property/6767906449167762/01a15adb-abcd-73e8-b7d4-55bd1147d676.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://mcclurems.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13322774541261369370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcclure-middle-school",
      "poi_latitude": "47.6367366",
      "poi_longitude": "-122.3589594",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-252-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfzWuKRMVkFQRGnCAstsA5Lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_3e85bca4f3b09be308d0c0f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Lincoln High School",
      "poi_type": "Education",
      "poi_address": "4400 Interlake Ave N, Seattle, WA 98103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://lincolnhs.seattleschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17228578893376073271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-high-school",
      "poi_latitude": "47.65995100000001",
      "poi_longitude": "-122.3398855",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-413-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn9R6x1YUkFQRNy55_Dg1GO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_28a3f25ecc212dcdb91e2c6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Bright Horizons at South Lake Union",
      "poi_type": "Education",
      "poi_address": "1275 Mercer St, Seattle, WA 98109, USA",
      "poi_short_description": "Well-run day care center, also offering preschool and kindergarten prep, that cares for kids from infancy.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-ab9c-76eb-939f-d8d726681e34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-ab9c-76eb-939f-d8d726681e34",
        "storage_key": "property/6767906449167762/01a15adb-ab9c-76eb-939f-d8d726681e34.webp",
        "width": 1152,
        "height": 768
      },
      "poi_business_url": "https://www.brighthorizons.com/daycare-centers/wa/seattle/1275-mercer-street-98109?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=weblink&utm_content=centerwebsite&IMS_SOURCE_SPECIFY=google%7Corganic%7Cgmb%7Cweblink%7Ccenterwebsite",
      "poi_directions_map_url": "https://maps.google.com/?cid=5021915168119637467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bright-horizons-at-south-lake-union",
      "poi_latitude": "47.6239936",
      "poi_longitude": "-122.3308231",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-573-5428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ07Tp8jAVkFQR28Xq9zxtsUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_ea0a152dba32473ee25f9e0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Young Child Academy of South Lake Union",
      "poi_type": "Education",
      "poi_address": "214 Minor Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-abb5-738b-b9ca-f9ee0bf94a6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-abb5-738b-b9ca-f9ee0bf94a6c",
        "storage_key": "property/6767906449167762/01a15adb-abb5-738b-b9ca-f9ee0bf94a6c.webp",
        "width": 1280,
        "height": 876
      },
      "poi_business_url": "http://youngchildacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2986066380317915790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "young-child-academy-of-south-lake-union",
      "poi_latitude": "47.6201668",
      "poi_longitude": "-122.33270939999998",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-282-7132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQQtZZLsVkFQRjvqVUo2jcCk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_f1513927c017d871a30f5c69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Cornish College of the Arts at Seattle University",
      "poi_type": "Education",
      "poi_address": "1000 Lenora St, Seattle, WA 98121, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-b295-716b-8d4f-111c72048898.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-b295-716b-8d4f-111c72048898",
        "storage_key": "property/6767906449167762/01a15adb-b295-716b-8d4f-111c72048898.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cornish.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16527929581452341339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cornish-college-of-the-arts-at-seattle-university",
      "poi_latitude": "47.6181961",
      "poi_longitude": "-122.3362411",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-296-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQaIjBzYVkFQRWzAjt2IAX-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_ad60223e17de8c80e8748548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Northeastern University Seattle",
      "poi_type": "Education",
      "poi_address": "401 Terry Ave N #103, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-bcaa-765b-9e1c-b9a5277c6af1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-bcaa-765b-9e1c-b9a5277c6af1",
        "storage_key": "property/6767906449167762/01a15adb-bcaa-765b-9e1c-b9a5277c6af1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://seattle.northeastern.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1809112595102075717&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeastern-university-seattle",
      "poi_latitude": "47.6228341",
      "poi_longitude": "-122.337364",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-467-5480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUwjkeTcVkFQRRYu-9VFCGxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_0365063a1befee963548902f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Seattle Pacific University",
      "poi_type": "Education",
      "poi_address": "3307 3rd Ave W, Seattle, WA 98119, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-b61b-7377-a73e-7fa1cb7903ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-b61b-7377-a73e-7fa1cb7903ed",
        "storage_key": "property/6767906449167762/01a15adb-b61b-7377-a73e-7fa1cb7903ed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://spu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11147637703534498643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-pacific-university",
      "poi_latitude": "47.6491714",
      "poi_longitude": "-122.3618554",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-281-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlXOYeKcVkFQRU9Psu21dtJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_5891e2826595822eec2ec6dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "University of Washington",
      "poi_type": "Education",
      "poi_address": "1410 NE Campus Pkwy, Seattle, WA 98195, USA",
      "poi_short_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_long_description": "This 1861 research school in Downtown Seattle is known for medicine, engineering & business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-5ed6-774a-a4e8-a07973def20e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15ad9-5ed6-774a-a4e8-a07973def20e",
        "storage_key": "property/6767906449167762/01a15ad9-5ed6-774a-a4e8-a07973def20e.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.washington.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7742862557588237219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-washington",
      "poi_latitude": "47.656591899999995",
      "poi_longitude": "-122.3126783",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-543-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6zWFnZIUkFQRoyu4AXksdGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_25a3263bdc60f992e434d92c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Museum of History & Industry (MOHAI)",
      "poi_type": "Entertainment",
      "poi_address": "860 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Iconic artifacts & diverse collections spotlighting Seattle's history in a lakefront park building.",
      "poi_long_description": "Iconic artifacts & diverse collections spotlighting Seattle's history in a lakefront park building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-b95c-76cd-a45e-321e9d7da404.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-b95c-76cd-a45e-321e9d7da404",
        "storage_key": "property/6767906449167762/01a15adb-b95c-76cd-a45e-321e9d7da404.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://mohai.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9653878537266285527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-history--industry-mohai",
      "poi_latitude": "47.6275834",
      "poi_longitude": "-122.3369027",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-324-1126",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b03-75ff-a75a-434687913314.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b03-75ff-a75a-434687913314",
        "storage_key": "property/6767906449167762/01a15adc-0b03-75ff-a75a-434687913314.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYwFwDsVkFQR10uGlmF3-YU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "ec_02f8bd232e7abb871a7e7f36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "The Center for Wooden Boats",
      "poi_type": "Entertainment",
      "poi_address": "1010 Valley St, Seattle, WA 98109, USA",
      "poi_short_description": "Museum preserving & exhibiting historic wooden boats, which can be rented & taken out on Lake Union.",
      "poi_long_description": "Museum preserving & exhibiting historic wooden boats, which can be rented & taken out on Lake Union.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-bc98-7159-93de-fb351063f3e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-bc98-7159-93de-fb351063f3e9",
        "storage_key": "property/6767906449167762/01a15adb-bc98-7159-93de-fb351063f3e9.webp",
        "width": 1280,
        "height": 735
      },
      "poi_business_url": "https://www.cwb.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11160173202728409972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-center-for-wooden-boats",
      "poi_latitude": "47.6262814",
      "poi_longitude": "-122.3364817",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-382-2628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b03-75ff-a75a-434687913314.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b03-75ff-a75a-434687913314",
        "storage_key": "property/6767906449167762/01a15adc-0b03-75ff-a75a-434687913314.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJWS5bSjoVkFQRdNt1FGbm4Jo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_7871e57729cad293647f03c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Museum of Pop Culture",
      "poi_type": "Entertainment",
      "poi_address": "325 5th Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Inspired by Jimi Hendrix, the museum includes items from icons ranging from Bo Diddley to Bob Dylan.",
      "poi_long_description": "Inspired by Jimi Hendrix, the museum includes items from icons ranging from Bo Diddley to Bob Dylan.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-c4a8-7227-8cca-4d1a8f24a6be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-c4a8-7227-8cca-4d1a8f24a6be",
        "storage_key": "property/6767906449167762/01a15adb-c4a8-7227-8cca-4d1a8f24a6be.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mopop.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15125666784235608082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-pop-culture",
      "poi_latitude": "47.6214824",
      "poi_longitude": "-122.3481245",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-770-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b03-75ff-a75a-434687913314.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b03-75ff-a75a-434687913314",
        "storage_key": "property/6767906449167762/01a15adc-0b03-75ff-a75a-434687913314.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8p6-EYVkFQREthJEc0p6dE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_81a4c51a59077789bd602707",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Chihuly Garden and Glass",
      "poi_type": "Entertainment",
      "poi_address": "305 Harrison St, Seattle, WA 98109, USA",
      "poi_short_description": "Art museum & sculpture garden showcasing Dale Chihuly's large, colorful glass works.",
      "poi_long_description": "Art museum & sculpture garden showcasing Dale Chihuly's large, colorful glass works.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-bf8c-7360-ab92-5ab84128f497.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-bf8c-7360-ab92-5ab84128f497",
        "storage_key": "property/6767906449167762/01a15adb-bf8c-7360-ab92-5ab84128f497.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chihulygardenandglass.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8881620907110491783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chihuly-garden-and-glass",
      "poi_latitude": "47.6205599",
      "poi_longitude": "-122.3504476",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-753-4940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b03-75ff-a75a-434687913314.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b03-75ff-a75a-434687913314",
        "storage_key": "property/6767906449167762/01a15adc-0b03-75ff-a75a-434687913314.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTtr1kUVkFQRh-YAfijbQXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_ef90214c79027fc0c72e1645",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Pacific Science Center",
      "poi_type": "Entertainment",
      "poi_address": "200 Sue Bird Ct N, Seattle, WA 98109, USA",
      "poi_short_description": "Rotating science exhibits plus laser light shows, a tropical butterfly house & IMAX movie theaters.",
      "poi_long_description": "Rotating science exhibits plus laser light shows, a tropical butterfly house & IMAX movie theaters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-c293-7451-bc31-f324aee7f718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-c293-7451-bc31-f324aee7f718",
        "storage_key": "property/6767906449167762/01a15adb-c293-7451-bc31-f324aee7f718.webp",
        "width": 651,
        "height": 651
      },
      "poi_business_url": "https://www.pacificsciencecenter.org/?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072473183036697406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pacific-science-center",
      "poi_latitude": "47.6200033",
      "poi_longitude": "-122.3515819",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-443-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b03-75ff-a75a-434687913314.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b03-75ff-a75a-434687913314",
        "storage_key": "property/6767906449167762/01a15adc-0b03-75ff-a75a-434687913314.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxZWvUwVkFQRPuvwC7JTqZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_388525765a4550d2f85890cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Climate Pledge Arena",
      "poi_type": "Entertainment",
      "poi_address": "334 1st Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Large venue hosts WNBA & NCAA basketball, roller derby, concerts & events for up to 17,000 people.",
      "poi_long_description": "Large venue hosts WNBA & NCAA basketball, roller derby, concerts & events for up to 17,000 people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-6d1a-72ac-8131-9b8318c13723.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15ad9-6d1a-72ac-8131-9b8318c13723",
        "storage_key": "property/6767906449167762/01a15ad9-6d1a-72ac-8131-9b8318c13723.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://climatepledgearena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15998104634649095719&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "climate-pledge-arena",
      "poi_latitude": "47.622094",
      "poi_longitude": "-122.353984",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-752-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a911-75eb-84ea-2e84134d8853.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a911-75eb-84ea-2e84134d8853",
        "storage_key": "property/6767906449167762/01a15ad9-a911-75eb-84ea-2e84134d8853.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ046-cUQVkFQRJy7KU2evBN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "ec_bf9dcf7c6240dced8affa494",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "The Crocodile",
      "poi_type": "Entertainment",
      "poi_address": "2505 1st Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Live music venue & bar presents diverse local & national bands in a low-key, causal setting.",
      "poi_long_description": "Live music venue & bar presents diverse local & national bands in a low-key, causal setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-edd6-73cd-b5e1-5582fb6d0612.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-edd6-73cd-b5e1-5582fb6d0612",
        "storage_key": "property/6767906449167762/01a15adb-edd6-73cd-b5e1-5582fb6d0612.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.thecrocodile.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9152732140488888689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-crocodile",
      "poi_latitude": "47.614767699999994",
      "poi_longitude": "-122.3492781",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-420-6351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b32-767f-8620-42531ba0475b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b32-767f-8620-42531ba0475b",
        "storage_key": "property/6767906449167762/01a15adc-0b32-767f-8620-42531ba0475b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0kh2WcVkFQRcREkdmMJBX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "ec_fe44bda4eded11cd5affcfe8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Moore Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1932 2nd Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Historic 1,800-seat theater, built in 1907, that hosts national music acts, comedians & other shows.",
      "poi_long_description": "Historic 1,800-seat theater, built in 1907, that hosts national music acts, comedians & other shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-c28f-757e-a33b-22c0264ff711.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-c28f-757e-a33b-22c0264ff711",
        "storage_key": "property/6767906449167762/01a15adb-c28f-757e-a33b-22c0264ff711.webp",
        "width": 1200,
        "height": 801
      },
      "poi_business_url": "http://www.stgpresents.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2952847665964977481&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moore-theatre",
      "poi_latitude": "47.6117575",
      "poi_longitude": "-122.3413928",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-682-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b32-767f-8620-42531ba0475b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b32-767f-8620-42531ba0475b",
        "storage_key": "property/6767906449167762/01a15adc-0b32-767f-8620-42531ba0475b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJebtKchYVkFQRSQ2vrU6f-ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_68d8bc654d7acdc4b3946f54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Paramount Theatre",
      "poi_type": "Entertainment",
      "poi_address": "911 Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Historic performing arts venue that hosts major musicals, plus big-name music & comedy acts.",
      "poi_long_description": "Historic performing arts venue that hosts major musicals, plus big-name music & comedy acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-cbb8-76f5-9b93-3703159ee08d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-cbb8-76f5-9b93-3703159ee08d",
        "storage_key": "property/6767906449167762/01a15adb-cbb8-76f5-9b93-3703159ee08d.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "http://www.stgpresents.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7759253808531622023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paramount-theatre",
      "poi_latitude": "47.6135244",
      "poi_longitude": "-122.3315134",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-682-1414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b32-767f-8620-42531ba0475b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b32-767f-8620-42531ba0475b",
        "storage_key": "property/6767906449167762/01a15adc-0b32-767f-8620-42531ba0475b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdWjwULVqkFQRh8ifgzporms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_d6ad902241adf402688f9d30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "The 5th Avenue Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1308 5th Ave, Seattle, WA 98101, USA",
      "poi_short_description": "Restored 1926 vaudeville theater with an ornate, Chinese-inspired interior now hosting musicals.",
      "poi_long_description": "Restored 1926 vaudeville theater with an ornate, Chinese-inspired interior now hosting musicals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-c711-7603-bf2f-12030688fe78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-c711-7603-bf2f-12030688fe78",
        "storage_key": "property/6767906449167762/01a15adb-c711-7603-bf2f-12030688fe78.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.5thavenue.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14800425353492837045&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-5th-avenue-theatre",
      "poi_latitude": "47.609188",
      "poi_longitude": "-122.3338546",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-625-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b32-767f-8620-42531ba0475b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b32-767f-8620-42531ba0475b",
        "storage_key": "property/6767906449167762/01a15adc-0b32-767f-8620-42531ba0475b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoT6vDbRqkFQRtTKgZ3GsZc0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_390361b48a7c20da78804072",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "ZoomCare South Lake Union - Urgent Care & Primary Care",
      "poi_type": "Health and Wellness",
      "poi_address": "116 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-c9af-70dc-9554-8f5cf8b37aa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-c9af-70dc-9554-8f5cf8b37aa4",
        "storage_key": "property/6767906449167762/01a15adb-c9af-70dc-9554-8f5cf8b37aa4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.zoomcare.com/clinic/zoomcare-south-lake-union?utm_campaign=gmb-site&utm_source=google&utm_medium=maps&utm_content=south-lake-union",
      "poi_directions_map_url": "https://maps.google.com/?cid=10320361917795137401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zoomcare-south-lake-union---urgent-care--primary-care",
      "poi_latitude": "47.6190425",
      "poi_longitude": "-122.338126",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 844-966-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK8KpQ44VkFQRefelD3xKOY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_639d2fcf3507435ac49dddcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Emergency Room at Harborview Medical Center | Seattle",
      "poi_type": "Health and Wellness",
      "poi_address": "325 9th Ave Main Hospital, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-cbad-705c-8369-9369edad0163.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-cbad-705c-8369-9369edad0163",
        "storage_key": "property/6767906449167762/01a15adb-cbad-705c-8369-9369edad0163.webp",
        "width": 1279,
        "height": 960
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/emergency-department-harborview?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDMxMC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14362926612777201649&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emergency-room-at-harborview-medical-center--seattle",
      "poi_latitude": "47.6045378",
      "poi_longitude": "-122.3242262",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-744-3074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP96-rLlqkFQR8e-WAahdU8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_dfcea91a25d6fcc38ed6f2dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Swedish Hospital - First Hill Campus",
      "poi_type": "Health and Wellness",
      "poi_address": "747 Broadway, Seattle, WA 98122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-ccd9-76da-a46b-52a67fc1faee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-ccd9-76da-a46b-52a67fc1faee",
        "storage_key": "property/6767906449167762/01a15adb-ccd9-76da-a46b-52a67fc1faee.webp",
        "width": 678,
        "height": 381
      },
      "poi_business_url": "https://www.swedish.org/locations/first-hill-campus?Is=location&y_source=1_OTU3NjkyMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5633867081434861685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "swedish-hospital---first-hill-campus",
      "poi_latitude": "47.608469",
      "poi_longitude": "-122.321481",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-386-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae82-7342-847f-0d37ecae5488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae82-7342-847f-0d37ecae5488",
        "storage_key": "property/6767906449167762/01a15ad9-ae82-7342-847f-0d37ecae5488.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9fNUchqkFQRdRCx1EKEL04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_29e4fed92999985910c43a2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "566 Denny Wy, Seattle, WA 98109, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-cfce-7677-8c5f-639b4b8e6586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-cfce-7677-8c5f-639b4b8e6586",
        "storage_key": "property/6767906449167762/01a15adb-cfce-7677-8c5f-639b4b8e6586.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-566+denny+way-seattle-wa-98109/id=11856",
      "poi_directions_map_url": "https://maps.google.com/?cid=6084857045479880761&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "47.6189603",
      "poi_longitude": "-122.3455144",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-204-1982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Xzcw0gVkFQROXjccD7BcVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_6a16e33ef28e3d05b3b5bfe2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Seattle Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2020 Western Ave, Seattle, WA 98121, USA",
      "poi_short_description": "Full-service downtown fitness center featuring squash courts, an indoor pool, and diverse group classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-ce0e-725c-8b71-4dc2b447b02e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-ce0e-725c-8b71-4dc2b447b02e",
        "storage_key": "property/6767906449167762/01a15adb-ce0e-725c-8b71-4dc2b447b02e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.sacdt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15505384259768133388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-athletic-club",
      "poi_latitude": "47.6108818",
      "poi_longitude": "-122.3439702",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-443-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxRG0N00VkFQRDKdpTdUwLtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_c4abd5ae9d8958d484ab463c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Row House Fitness South Lake Union",
      "poi_type": "Health and Wellness",
      "poi_address": "419 Fairview Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Welcoming fitness studio offering motivating rowing and strength training classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-cfc2-7098-889a-69dd7b500058.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-cfc2-7098-889a-69dd7b500058",
        "storage_key": "property/6767906449167762/01a15adb-cfc2-7098-889a-69dd7b500058.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.therowhouse.com/location/south-lake-union",
      "poi_directions_map_url": "https://maps.google.com/?cid=1252224496561265193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "row-house-fitness-south-lake-union",
      "poi_latitude": "47.622688499999995",
      "poi_longitude": "-122.33456599999998",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-338-6007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx9--u94VkFQRKZqTiIvLYBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_084cb195da92908a30a4867d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "DRIFT Yoga + Juice Bar",
      "poi_type": "Health and Wellness",
      "poi_address": "1251 Harrison St, Seattle, WA 98109, USA",
      "poi_short_description": "Clean retreat offering a range of yoga classes as well as a juice and goodie bar, plus a retail space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-cfc2-7098-889a-6efd35f4006a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-cfc2-7098-889a-6efd35f4006a",
        "storage_key": "property/6767906449167762/01a15adb-cfc2-7098-889a-6efd35f4006a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.driftyogajuicebar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5330996277376087505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "drift-yoga--juice-bar",
      "poi_latitude": "47.6218176",
      "poi_longitude": "-122.331318",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-618-3928",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c41553c19d54",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c41553c19d54.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVamYlEVkFQR0XXuk96A-0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_caf0bf3a74f2df24d70e59bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Pure Barre Seattle | Queen Anne",
      "poi_type": "Health and Wellness",
      "poi_address": "500 Mercer St Ste c205, Seattle, WA 98109, USA",
      "poi_short_description": "Outpost in a chain of exercise studios with ballet-inspired workouts & a clothing retail area.",
      "poi_long_description": "Outpost in a chain of exercise studios with ballet-inspired workouts & a clothing retail area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-cfa9-71ee-a92f-61a1ac314d9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-cfa9-71ee-a92f-61a1ac314d9e",
        "storage_key": "property/6767906449167762/01a15adb-cfa9-71ee-a92f-61a1ac314d9e.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/seattle-queen-anne-wa",
      "poi_directions_map_url": "https://maps.google.com/?cid=488272139700119907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre-seattle--queen-anne",
      "poi_latitude": "47.6250733",
      "poi_longitude": "-122.3472849",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-327-9817",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ-cPR0cVkFQRY6mLkOywxgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_88de803feb83b68e25a4579d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Lake Union Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "860 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "12-acre lakefront park with boat launch, model-boat pond, Center for Wooden Boats & spray features.",
      "poi_long_description": "12-acre lakefront park with boat launch, model-boat pond, Center for Wooden Boats & spray features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-d414-731e-86dc-ee08640c46ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-d414-731e-86dc-ee08640c46ef",
        "storage_key": "property/6767906449167762/01a15adb-d414-731e-86dc-ee08640c46ef.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/lake-union-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021986494381383037&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-union-park",
      "poi_latitude": "47.6277112",
      "poi_longitude": "-122.3368686",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae83-7630-9137-3142aad65afb",
        "storage_key": "property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbpC3DsVkFQRfV3tymwamMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_5dc4a8624718cf2c35284a6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Gas Works Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2101 N Northlake Way, Seattle, WA 98103, USA",
      "poi_short_description": "Former site of an oil plant is now a 20-acre park with picnic facilities & dramatic city views.",
      "poi_long_description": "Former site of an oil plant is now a 20-acre park with picnic facilities & dramatic city views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-814d-7658-87d8-7b3ecad5e9cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15ad9-814d-7658-87d8-7b3ecad5e9cc",
        "storage_key": "property/6767906449167762/01a15ad9-814d-7658-87d8-7b3ecad5e9cc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.seattle.gov/parks/allparks/gas-works-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2192784265468010902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gas-works-park",
      "poi_latitude": "47.6456308",
      "poi_longitude": "-122.3343532",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae83-7630-9137-3142aad65afb",
        "storage_key": "property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf7BbsgIVkFQRlmFJ7KtVbh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_b57e25b0deea81571a4be09a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Cascade Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "333 Pontius Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Long-standing neighborhood park with playgrounds, green space & an adjoining community garden.",
      "poi_long_description": "Long-standing neighborhood park with playgrounds, green space & an adjoining community garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-d5bb-715b-bd45-0b18c2606204.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-d5bb-715b-bd45-0b18c2606204",
        "storage_key": "property/6767906449167762/01a15adb-d5bb-715b-bd45-0b18c2606204.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/cascade-playground",
      "poi_directions_map_url": "https://maps.google.com/?cid=9452615793284929502&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cascade-playground",
      "poi_latitude": "47.621641399999994",
      "poi_longitude": "-122.3326097",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae83-7630-9137-3142aad65afb",
        "storage_key": "property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtbWb0TYVkFQR3tf-XPtvLoM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_dfab380261d11f22cbafb8a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Denny Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Dexter Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "Park's 4 acres is home to the central offices of the Parks Department, flowers, paths & a play area.",
      "poi_long_description": "Park's 4 acres is home to the central offices of the Parks Department, flowers, paths & a play area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-d978-75b1-8d0d-91ec04d3cb0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-d978-75b1-8d0d-91ec04d3cb0e",
        "storage_key": "property/6767906449167762/01a15adb-d978-75b1-8d0d-91ec04d3cb0e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/denny-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17697390754654843374&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "denny-park",
      "poi_latitude": "47.619053",
      "poi_longitude": "-122.340936",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae83-7630-9137-3142aad65afb",
        "storage_key": "property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7cLUtUkVkFQR7vF7ZiDDmfU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_9847df1b3da3979fe5abf169",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Terry Pettus Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2001 Fairview Ave E, Seattle, WA 98102, USA",
      "poi_short_description": "Small park with a dock and waterfront views of Lake Union and the Space Needle.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-d874-75cb-b685-22d4e2caf288.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-d874-75cb-b685-22d4e2caf288",
        "storage_key": "property/6767906449167762/01a15adb-d874-75cb-b685-22d4e2caf288.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/terry-pettus-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6658747617718632444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terry-pettus-park",
      "poi_latitude": "47.636752",
      "poi_longitude": "-122.32933",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae83-7630-9137-3142aad65afb",
        "storage_key": "property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cx13yEVkFQR_P8Yw62faFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_d9a97842a61cbf0b905beeb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Fairview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 Fairview Ave E, Seattle, WA 98102, USA",
      "poi_short_description": "Cozy lakeside natural area with a boat launch, stone benches, picnic tables & bike racks.",
      "poi_long_description": "Cozy lakeside natural area with a boat launch, stone benches, picnic tables & bike racks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-dddb-713d-a52a-9b285b218e3f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-dddb-713d-a52a-9b285b218e3f",
        "storage_key": "property/6767906449167762/01a15adb-dddb-713d-a52a-9b285b218e3f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/fairview-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14211911986482861245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairview-park",
      "poi_latitude": "47.6476561",
      "poi_longitude": "-122.3249219",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae83-7630-9137-3142aad65afb",
        "storage_key": "property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEQbqleQUkFQRvVRtXafaOsU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_203b07ef6d01da3730c8c5a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Fairview Walkway",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1251 Fairview Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-e99d-7216-aba3-e03cd4f39d88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-e99d-7216-aba3-e03cd4f39d88",
        "storage_key": "property/6767906449167762/01a15adb-e99d-7216-aba3-e03cd4f39d88.webp",
        "width": 1280,
        "height": 1269
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/fairview-walkway",
      "poi_directions_map_url": "https://maps.google.com/?cid=2075537544320733973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairview-walkway",
      "poi_latitude": "47.6303418",
      "poi_longitude": "-122.3289346",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae83-7630-9137-3142aad65afb",
        "storage_key": "property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwTRiyQVkFQRFVM5X2bKzRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_8b8611414b48b4a50b8bbe52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Sunnyside Ave N Boat Ramp",
      "poi_type": "Entertainment",
      "poi_address": "2351 N Northlake Way, Seattle, WA 98103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-db7d-72ea-a14e-5ceafe6eeb0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-db7d-72ea-a14e-5ceafe6eeb0b",
        "storage_key": "property/6767906449167762/01a15adb-db7d-72ea-a14e-5ceafe6eeb0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/sunnyside-ave-n-boat-ramp",
      "poi_directions_map_url": "https://maps.google.com/?cid=2617833945847917530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunnyside-ave-n-boat-ramp",
      "poi_latitude": "47.650208799999994",
      "poi_longitude": "-122.3306884",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-684-7249",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b53-75ea-8f07-d0df2c8fd305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b53-75ea-8f07-d0df2c8fd305",
        "storage_key": "property/6767906449167762/01a15adc-0b53-75ea-8f07-d0df2c8fd305.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJETiDfvwUkFQR2ms5lxpqVCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_0899b7ea684889512eddf968",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "South Passage Point Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3320 Fuhrman Ave E, Seattle, WA 98102, USA",
      "poi_short_description": "Laid-back waterside greenspace with picnic tables and a kayak launch.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-daff-7298-a869-aed0aa1c98a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-daff-7298-a869-aed0aa1c98a7",
        "storage_key": "property/6767906449167762/01a15adb-daff-7298-a869-aed0aa1c98a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/south-passage-point",
      "poi_directions_map_url": "https://maps.google.com/?cid=15444371416361138378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-passage-point-park",
      "poi_latitude": "47.6522301",
      "poi_longitude": "-122.3224152",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae83-7630-9137-3142aad65afb",
        "storage_key": "property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR20tevAUkFQRyvhms_ltVdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_972ee07a903859f58cc07e85",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Westlake Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4th Ave, Pine St, Seattle, WA 98101, USA",
      "poi_short_description": "Monorail station with marble floors, multiple colorful, tiled murals & an old-school clock.",
      "poi_long_description": "Monorail station with marble floors, multiple colorful, tiled murals & an old-school clock.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-e42c-7486-9897-d7ab3629034e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-e42c-7486-9897-d7ab3629034e",
        "storage_key": "property/6767906449167762/01a15adb-e42c-7486-9897-d7ab3629034e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.seattlemonorail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14068683656837464517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westlake-center",
      "poi_latitude": "47.6120708",
      "poi_longitude": "-122.3369693",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0baf-712e-a141-49f95da8e230.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0baf-712e-a141-49f95da8e230",
        "storage_key": "property/6767906449167762/01a15adc-0baf-712e-a141-49f95da8e230.webp",
        "width": 153,
        "height": 192
      },
      "poi_google_place_id": "ChIJrWm2x7RqkFQRxQEkLz8BPsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_85c6ff8d1b43c654274b336b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "McGraw Square",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "531 Stewart St Westlake Ave &, Stewart St, Seattle, WA 98101, USA",
      "poi_short_description": "Small downtown pedestrian plaza with a memorial statue & occasional food vendors.",
      "poi_long_description": "Small downtown pedestrian plaza with a memorial statue & occasional food vendors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-e368-74a8-baef-3e47ceb33099.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-e368-74a8-baef-3e47ceb33099",
        "storage_key": "property/6767906449167762/01a15adb-e368-74a8-baef-3e47ceb33099.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/mcgraw-square",
      "poi_directions_map_url": "https://maps.google.com/?cid=4950524839590417307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcgraw-square",
      "poi_latitude": "47.61301",
      "poi_longitude": "-122.3375436",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae83-7630-9137-3142aad65afb",
        "storage_key": "property/6767906449167762/01a15ad9-ae83-7630-9137-3142aad65afb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSmIR0sVkFQRm9OI0xzMs0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_ec2e6c2f678cb4fe727c688f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Kenmore Air - Lake Union",
      "poi_type": "Transportation & Transit",
      "poi_address": "950 Westlake Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-e42f-772b-9cc2-cc116d4426bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-e42f-772b-9cc2-cc116d4426bd",
        "storage_key": "property/6767906449167762/01a15adb-e42f-772b-9cc2-cc116d4426bd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kenmoreair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4745136566379464655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kenmore-air---lake-union",
      "poi_latitude": "47.6285542",
      "poi_longitude": "-122.3398153",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 866-435-9524",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0c12-70e5-b868-e091a9c8763e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0c12-70e5-b868-e091a9c8763e",
        "storage_key": "property/6767906449167762/01a15adc-0c12-70e5-b868-e091a9c8763e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJr5yeBTwVkFQRz8fD-ZAc2kE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_95d98ef84597981e4a948a87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Colman Dock",
      "poi_type": "Transportation & Transit",
      "poi_address": "801 Alaskan Wy, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-e733-729a-bba2-17aab5870180.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-e733-729a-bba2-17aab5870180",
        "storage_key": "property/6767906449167762/01a15adb-e733-729a-bba2-17aab5870180.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wsdot.com/ferries/vesselwatch/terminaldetail.aspx?terminalid=7",
      "poi_directions_map_url": "https://maps.google.com/?cid=13467170663738880714&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colman-dock",
      "poi_latitude": "47.6028305",
      "poi_longitude": "-122.3378842",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 888-808-7977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGx2xvK9qkFQRyrK31V0A5bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferry_service"
    },
    {
      "id": "ec_09e9499f798d7fcfbd614cb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Amtrak King Street Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "303 S Jackson St, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-ea0f-7346-b216-1150fe62337f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-ea0f-7346-b216-1150fe62337f",
        "storage_key": "property/6767906449167762/01a15adb-ea0f-7346-b216-1150fe62337f.webp",
        "width": 750,
        "height": 555
      },
      "poi_business_url": "https://www.amtrak.com/stations/sea",
      "poi_directions_map_url": "https://maps.google.com/?cid=2567709630967656346&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amtrak-king-street-station",
      "poi_latitude": "47.5985814",
      "poi_longitude": "-122.3300238",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 866-332-1201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG8VGPwBrkFQRmi8tGE5WoiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_6c8f9494ad0e7f59f8cac891",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Seattle-Tacoma International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "17801 International Blvd, SeaTac, WA 98158, USA",
      "poi_short_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_long_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-e98d-7020-82cd-55298f879a88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-e98d-7020-82cd-55298f879a88",
        "storage_key": "property/6767906449167762/01a15adb-e98d-7020-82cd-55298f879a88.webp",
        "width": 1200,
        "height": 798
      },
      "poi_business_url": "https://www.portseattle.org/sea-tac",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084442547078838199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-tacoma-international-airport",
      "poi_latitude": "47.4483652",
      "poi_longitude": "-122.3085927",
      "poi_miles_from_property": "14.4 mi",
      "poi_walking_minutes": "5 hours 29 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0c12-70e5-b868-e091a9c8763e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0c12-70e5-b868-e091a9c8763e",
        "storage_key": "property/6767906449167762/01a15adc-0c12-70e5-b868-e091a9c8763e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f7qQlVDkFQRtzfcx8TZ05k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_6199921e5f75667c40c4a938",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "FRS Clipper (Clipper Vacations)",
      "poi_type": "Transportation & Transit",
      "poi_address": "2701 Alaskan Wy Pier 69, Seattle, WA 98121, USA",
      "poi_short_description": "Day trips & themed cruises on the Salish Sea, including seasonal activities like whale watching.",
      "poi_long_description": "Day trips & themed cruises on the Salish Sea, including seasonal activities like whale watching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-ec70-7516-9bef-d14c5c2e8f01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-ec70-7516-9bef-d14c5c2e8f01",
        "storage_key": "property/6767906449167762/01a15adb-ec70-7516-9bef-d14c5c2e8f01.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://www.clippervacations.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11607470813794123415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frs-clipper-clipper-vacations",
      "poi_latitude": "47.6136659",
      "poi_longitude": "-122.3540806",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-888-2535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0b53-75ea-8f07-d0df2c8fd305.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0b53-75ea-8f07-d0df2c8fd305",
        "storage_key": "property/6767906449167762/01a15adc-0b53-75ea-8f07-d0df2c8fd305.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJBxdCmVEVkFQRl77pxDQFFqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ferry_service"
    },
    {
      "id": "ec_9c838e82f8cc37922fdf9a1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Amazon Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "440 Terry Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-f014-703e-b8fb-616976cd32f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-f014-703e-b8fb-616976cd32f8",
        "storage_key": "property/6767906449167762/01a15adb-f014-703e-b8fb-616976cd32f8.webp",
        "width": 568,
        "height": 346
      },
      "poi_business_url": "https://www.aboutamazon.com/workplace/corporate-offices",
      "poi_directions_map_url": "https://maps.google.com/?cid=15534617866147706229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-corporate-headquarters",
      "poi_latitude": "47.6227501",
      "poi_longitude": "-122.3367548",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 206-266-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxQbczcVkFQRdbUrsaQMltc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_958135d8bd437e86bcbf3017",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Fred Hutch Cancer Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1354 Aloha St, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-f0e0-76c9-9943-a7514df82678.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-f0e0-76c9-9943-a7514df82678",
        "storage_key": "property/6767906449167762/01a15adb-f0e0-76c9-9943-a7514df82678.webp",
        "width": 1022,
        "height": 575
      },
      "poi_business_url": "https://www.fredhutch.org/?utm_source=gbp&utm_medium=organic&utm_content=primary_business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13660788334964817360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-hutch-cancer-center",
      "poi_latitude": "47.626675",
      "poi_longitude": "-122.330091",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-557-0555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzT5V0iQVkFQR0L1g2ZzelL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_f17fb28dbe8f39a4177bfc8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Gates Foundation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 5th Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-ff0e-763d-9135-f93c4878fb49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-ff0e-763d-9135-f93c4878fb49",
        "storage_key": "property/6767906449167762/01a15adb-ff0e-763d-9135-f93c4878fb49.webp",
        "width": 1280,
        "height": 1013
      },
      "poi_business_url": "http://gatesfoundation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12667357819156295453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gates-foundation",
      "poi_latitude": "47.6233319",
      "poi_longitude": "-122.3465813",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 206-709-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3d0rEcVkFQRHe-TbdJ-y68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_6f7aac2709bbf16cacacbdd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Google Seattle - South Lake Union",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1021 Valley St, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-f6cd-707a-b027-bcf8b70c646e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-f6cd-707a-b027-bcf8b70c646e",
        "storage_key": "property/6767906449167762/01a15adb-f6cd-707a-b027-bcf8b70c646e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://google.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12652264517921896618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "google-seattle---south-lake-union",
      "poi_latitude": "47.6254907",
      "poi_longitude": "-122.3365714",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVDM7PkVkFQRqngDY4vfla8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_210380905d60241b48023619",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Fred Hutch Sloan Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "820 Yale Ave N, Seattle, WA 98109, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-f343-72b9-af15-8086f1f77200.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-f343-72b9-af15-8086f1f77200",
        "storage_key": "property/6767906449167762/01a15adb-f343-72b9-af15-8086f1f77200.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.fredhutch.org/en/about/fred-hutch-locations/sloan-clinic.html?utm_source=gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15751361399669164805&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-hutch-sloan-clinic",
      "poi_latitude": "47.6264891",
      "poi_longitude": "-122.3307258",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-557-0555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae82-7342-847f-0d37ecae5488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae82-7342-847f-0d37ecae5488",
        "storage_key": "property/6767906449167762/01a15ad9-ae82-7342-847f-0d37ecae5488.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFwVexYoVkFQRBYsUHL0TmNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_838bc82e09dcdbd70b902286",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Seattle Children's Research Institute: Jack R. MacDonald Building",
      "poi_type": "Education",
      "poi_address": "1900 9th Ave, Seattle, WA 98101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0296-739f-9879-61c2762af967.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adc-0296-739f-9879-61c2762af967",
        "storage_key": "property/6767906449167762/01a15adc-0296-739f-9879-61c2762af967.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.seattlechildrens.org/locations/jrm/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2521885730427840252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-childrens-research-institute-jack-r-macdonald-building",
      "poi_latitude": "47.6158028",
      "poi_longitude": "-122.3345023",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 206-884-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a92a-7009-b192-c20bcbdafef3",
        "storage_key": "property/6767906449167762/01a15ad9-a92a-7009-b192-c20bcbdafef3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmWxygEoVkFQR_CZH1rWJ_yI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "research_institute"
    },
    {
      "id": "ec_245d3fce4743aa3b461d3281",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Virginia Mason Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1100 9th Ave, Seattle, WA 98101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-f864-7438-8def-fb9e5e8738bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-f864-7438-8def-fb9e5e8738bd",
        "storage_key": "property/6767906449167762/01a15adb-f864-7438-8def-fb9e5e8738bd.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.vmfh.org/our-hospitals/virginia-mason-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=10908412116613558774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virginia-mason-medical-center",
      "poi_latitude": "47.609935",
      "poi_longitude": "-122.3275125",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 206-624-1144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae82-7342-847f-0d37ecae5488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae82-7342-847f-0d37ecae5488",
        "storage_key": "property/6767906449167762/01a15ad9-ae82-7342-847f-0d37ecae5488.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx3kMjY8NkFQR9nFRWgZ3Ypc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_089134b9e7c37474c1f6228e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Harborview Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "325 9th Ave Main Hospital, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-7cd7-71ad-9618-460b6ec9a21e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15ad9-7cd7-71ad-9618-460b6ec9a21e",
        "storage_key": "property/6767906449167762/01a15ad9-7cd7-71ad-9618-460b6ec9a21e.webp",
        "width": 1279,
        "height": 903
      },
      "poi_business_url": "https://www.uwmedicine.org/locations/harborview-medical-center?utm_source=extnet&utm_medium=organic&utm_campaign=website_clicks&y_source=1_MTAwNDcxNDM0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6803544737971406536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harborview-medical-center",
      "poi_latitude": "47.6039167",
      "poi_longitude": "-122.323905",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 206-744-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-ae82-7342-847f-0d37ecae5488.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-ae82-7342-847f-0d37ecae5488",
        "storage_key": "property/6767906449167762/01a15ad9-ae82-7342-847f-0d37ecae5488.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7w3EijcVkFQRyIZDeOQLa14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_ae6faf8e1b31607e905037f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Nordstrom Corporate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1700 7th Ave, Seattle, WA 98101, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-f724-716c-b247-d2bd91bb3d8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-f724-716c-b247-d2bd91bb3d8a",
        "storage_key": "property/6767906449167762/01a15adb-f724-716c-b247-d2bd91bb3d8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://shop.nordstrom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15741913563102307146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nordstrom-corporate",
      "poi_latitude": "47.6126024",
      "poi_longitude": "-122.3359916",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 888-282-6060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15ad9-a91f-7369-96cd-7d03be4b1cfc",
        "storage_key": "property/6767906449167762/01a15ad9-a91f-7369-96cd-7d03be4b1cfc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ef53EoVkFQRSuOdPfuCdto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_7a01f27093ece0257e1003f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "poi_name": "Seattle City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 4th Ave, Seattle, WA 98104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adb-faeb-7423-8b47-1452ffbe8d95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a15adb-faeb-7423-8b47-1452ffbe8d95",
        "storage_key": "property/6767906449167762/01a15adb-faeb-7423-8b47-1452ffbe8d95.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.seattle.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12499598841282423791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-city-hall",
      "poi_latitude": "47.6038106",
      "poi_longitude": "-122.3299368",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 206-684-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167762/01a15adc-0bba-703c-88f5-b9a4ef3fad8b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a15adc-0bba-703c-88f5-b9a4ef3fad8b",
        "storage_key": "property/6767906449167762/01a15adc-0bba-703c-88f5-b9a4ef3fad8b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVY3XoLBqkFQR7-uFoet-d60",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    }
  ],
  "office_hours": [
    {
      "id": "ec_4b95ee1b808bb098b3fd98c6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e3f505ba2b1b2a53e6395fc9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c53847c1e97b06dbb9715059",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_1e747f76ba9818e4ebba7959",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3fc483dfcdb818e00af84d4c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_23a0ace9cf75a587dc9db862",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_b9b3bb19cb3f5d231bde8444",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "rating": "5",
      "name": "Venkatesh",
      "text": "I've absolutely loved living at One Lakefront. The location is hard to beat - close to SLU, with easy access to work, restaurants, and everything Seattle has to offer. The amenities are excellent, the building is always well-maintained, and the maintenance team is responsive and reliable whenever needed.\n\nA special shoutout to Tessa in the leasing office. She has been amazing to work with - professional, friendly, and genuinely invested in helping residents.\n\nOverall, One Lakefront has exceeded my expectations, and I would highly recommend it to anyone looking for a comfortable, well-managed community in a fantastic location.",
      "date": "2026-07-09",
      "title": "false"
    },
    {
      "id": "ec_2efc0a34060378d5b7f59ec5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "rating": "5",
      "name": "Kyle Kingsley",
      "text": "Lived at One Lakefront for two years and I had great time calling it home. I loved my apartment and all of the staff who work there are top notch (especially Tessa!). I had one small maintenance request in the years I was there and it was resolved within a day. It’s a quiet building and just a really great place to live. I will truly miss it! 5 stars all the way!",
      "date": "2026-05-28",
      "title": "false"
    },
    {
      "id": "ec_0ddac88f74c1d02fccd1928a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "rating": "5",
      "name": "Ravi Jotwani",
      "text": "Tess has been amazing at helping me find an apartment sight unseen. She has been super responsive and meticulous in answering all of my questions. She was even able to go up to the unit I was interested in and grab measurements of all of the rooms. The leasing process has been very straightforward so far, highly recommend.",
      "date": "2026-07-01",
      "title": "false"
    },
    {
      "id": "ec_e093ae305054f58229209e14",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "rating": "5",
      "name": "Anhiti Patnaik",
      "text": "We’ve enjoyed every part of living here! It is so well designed, well maintained, and worth every buck. We looked at almost 15 apartment complexes in the SLU area before committing to this. Not only did we get a fantastic view of Lake Union from our 6th floor home (photos attached are of the rooftop and common area), but the management addressed all our queries, needs, and made the move in and settling process super smooth and efficient. The common areas are beautiful and well-maintained, neighbours are a good mix of young working professionals with good ethnic diversity. It is a super pet friendly building with dedicated dog spaces on the rooftops. Common areas include a very good gym, courtyard, 2 rooftops with barbecue set up, panoramic lake view, a club room with pool, common work spaces, and WIFI. One side of the building faces the lake, the other faces Dexter Ave, and yet, it is pretty quiet and away from the traffic noise and homeless situation. This was one of our main reasons to move here, rather than SLU or Queen Anne. Super accessible on the no. 62, 40, E line bus routes for easy commute. The included appliances are top notch, heating and power is reliable, maintenance is pretty good, and management team kind, dedicated, and supportive. Would totally recommend!",
      "date": "2024-11-23",
      "title": "false"
    },
    {
      "id": "ec_35e8fceadf92203b7aca3929",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "rating": "4",
      "name": "Kaira",
      "text": "Super clean and well-maintained! Large fitness center and tremendous rooftop view. Spacious and quiet unit. Heartwarming management. They were so helpful and professional! Highly recommend!\n\n---------- update ----------\noh no. stolen package.\n\nYes. Even luxury apt has package missing issue. I believe the management team had tried their best to prevent missing packages. It's more about people who lives here and whoever comes in.",
      "date": "2025-01-06",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "in-unit-washer-dryer-seattle-apartments",
      "search_query": "apartments with in-unit washer and dryer Seattle",
      "category": "Amenity",
      "h1_title": "Convenient Apartments with In-Unit Laundry",
      "h2_subtitle": "Find Seattle apartments featuring an in-unit washer and dryer. Enjoy the convenience of laundry without leaving your apartment at One Lakefront.",
      "page_copy": "Discover the ease of living at One Lakefront, where each apartment boasts an in-unit washer and dryer, ensuring you enjoy laundry convenience without stepping out of your home. Located in the vibrant Westlake neighborhood of Seattle, our community not only offers practical amenities but also luxurious features like quartz countertops and stylish tile backsplashes.\n\nAt One Lakefront, you’ll experience modern living combined with beautiful surroundings. With direct indoor access to Westlake Avenue and Dexter Avenue, commuting is a breeze. Unwind at 'The Boardroom,' our unique lounge overlooking Lake Union, complete with a pool table and a large flat screen TV. Experience efficiency and comfort with double pane windows and CAT-6 wiring, making everyday life smoother.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Washer and Dryer",
      "seo_description": "Explore One Lakefront Seattle - modern apartments with in-unit washer and dryer, offering unmatched convenience in the Westlake neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-westlake-neighborhood",
      "search_query": "pet friendly apartments Westlake neighborhood",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Living in Westlake",
      "h2_subtitle": "Discover pet-friendly apartments in the Westlake neighborhood of Seattle. One Lakefront offers a welcoming space for you and your furry friends.",
      "page_copy": "Welcome to One Lakefront, a pet-friendly community in Seattle's lively Westlake neighborhood. Our spacious apartments are designed to accommodate both you and your furry companions, ensuring a comfortable living experience. Enjoy the convenience of nearby parks and vibrant surroundings where your pets can roam and play.\n\nAt One Lakefront, we understand that pets are family. That's why our community offers amenities like CAT-6 wiring for your tech needs and double-pane windows for a peaceful atmosphere. Relax at 'The Boardroom,' our exclusive lounge, or enjoy the scenic views of Lake Union. Here, you and your pets can thrive in a welcoming and luxurious environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Westlake",
      "seo_description": "Find pet-friendly apartments at One Lakefront in Seattle's Westlake neighborhood, offering a great living space for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "rooftop-terrace-lake-union-views-apartments",
      "search_query": "rooftop terrace apartments Lake Union views",
      "category": "Amenity",
      "h1_title": "Stunning Rooftop Terrace with Lake Views",
      "h2_subtitle": "Explore One Lakefront's rooftop terrace apartments with breathtaking Lake Union views. Experience Seattle living like never before.",
      "page_copy": "Imagine waking up to panoramic views of Lake Union every day at One Lakefront. Our apartments are equipped with a stunning rooftop terrace, providing a unique vantage point of Seattle's beautiful waterfront. Nestled in the dynamic Westlake neighborhood, our community offers modern living combined with the tranquility of nature.\n\nBesides the awe-inspiring views, enjoy deluxe features such as quartz countertops and double pane windows that enhance your lifestyle experience. Whether relaxing in the vintage-style 'The Boardroom' or savoring the lively community atmosphere, One Lakefront promises an unmatched residential experience, enriched by an enviable rooftop perspective of Lake Union.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Terrace Apartments with Lake Union Views",
      "seo_description": "Discover One Lakefront's rooftop terrace apartments offering amazing Lake Union views and unparalleled Seattle living!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "state-of-the-art-fitness-center-apartments-king-county",
      "search_query": "apartments with state of the art fitness center King County",
      "category": "Amenity",
      "h1_title": "King County Apartments with Modern Gym",
      "h2_subtitle": "Experience a state-of-the-art fitness center at One Lakefront in King County. Our Seattle apartments cater to all your fitness needs and more.",
      "page_copy": "At One Lakefront, located in the heart of King County's vibrant Westlake neighborhood, you can stay fit and active with our state-of-the-art fitness center. Our Seattle apartments provide modern exercise equipment, ensuring you have everything you need for a comprehensive workout right at your doorstep.\n\nBeyond fitness, One Lakefront offers luxurious features like quartz countertops and double pane windows, enhancing comfort and style. Enjoy easy access to both Westlake and Dexter Avenues, making commutes straightforward. Relax in 'The Boardroom,' our vintage lounge with lake views, perfect after a vigorous workout session in our top-tier gym.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Modern Fitness Center in King County",
      "seo_description": "One Lakefront offers Seattle apartments with a state-of-the-art fitness center. Enjoy modern living and exercise facilities in King County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "kayak-access-apartments-seattle-wa-westlake",
      "search_query": "kayak access apartments Seattle WA",
      "category": "Amenity",
      "h1_title": "Seattle Kayak Access Apartments",
      "h2_subtitle": "Find kayak access apartments in Seattle, WA at One Lakefront. Enjoy direct access to Lake Union and outdoor adventures every day.",
      "page_copy": "One Lakefront is the perfect home for water enthusiasts seeking kayak access apartments in Seattle, WA. Located in the scenic Westlake neighborhood, our community offers seamless lake access, allowing you to indulge in kayaking adventures on Lake Union any time you wish.\n\nThe vibrant surroundings and easy accessibility to the water make One Lakefront a haven for those who love Seattle's outdoor lifestyle. Along with water activities, residents enjoy modern amenities, including CAT-6 wiring, double pane windows, and exclusive use of 'The Boardroom' - a luxurious lakeside lounge. Embrace a blend of adventure and comfort at our unique community.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kayak Access Apartments in Seattle, WA",
      "seo_description": "Explore kayak access apartments at One Lakefront in Seattle, WA. Enjoy lifestyle and water activities in the beautiful Westlake neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-westlake-seattle",
      "search_query": "one bedroom apartments westlake seattle",
      "category": "Floorplan",
      "h1_title": "Modern One Bedroom Apartments in Westlake",
      "h2_subtitle": "Discover spacious one bedroom apartments in Westlake, Seattle at One Lakefront. Experience comfort and convenience in a prime location.",
      "page_copy": "Located in the vibrant Westlake neighborhood, One Lakefront offers modern one bedroom apartments tailored for comfort and style. These spacious apartments in Seattle feature contemporary finishes like quartz countertops and double pane windows, ensuring a serene living environment.\n\nSituated near the scenic Lake Union, residents can enjoy easy access to both nature and city life. Our community amenities, including CAT-6 wiring and 'The Boardroom' - a unique vintage lounge, add to the appeal of calling One Lakefront home. Embrace the perfect blend of urban lifestyle and natural beauty in our exceptional Westlake apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Westlake, Seattle",
      "seo_description": "Find modern one bedroom apartments at One Lakefront in Westlake, Seattle. Experience comfort, style, and convenience in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-king-county-westlake",
      "search_query": "2 bedroom apartments king county",
      "category": "Floorplan",
      "h1_title": "Stylish 2 Bedroom Apartments in King County",
      "h2_subtitle": "Discover spacious 2 bedroom apartments at One Lakefront, located in King County's vibrant Westlake neighborhood. Enjoy urban living with modern amenities.",
      "page_copy": "Nestled in the heart of King County's Westlake neighborhood, One Lakefront offers stylish 2 bedroom apartments designed for modern living. These thoughtfully crafted apartments feature quartz countertops, double pane windows, and CAT-6 wiring, providing both comfort and efficiency.\n\nOur location in Seattle provides residents with seamless access to vibrant city life and picturesque Lake Union views. Enjoy exclusive community amenities such as 'The Boardroom,' a chic vintage lounge that offers the perfect blend of relaxation and entertainment. Choose One Lakefront to experience a superior lifestyle in King County's exciting urban landscape.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in King County",
      "seo_description": "Explore 2 bedroom apartments at One Lakefront in King County. Enjoy modern living with beautiful views in the Westlake neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-98109-westlake",
      "search_query": "3 bedroom apartments near 98109",
      "category": "Floorplan",
      "h1_title": "Spacious 3 Bedroom Apartments Near 98109",
      "h2_subtitle": "Find luxurious 3 bedroom apartments near 98109 at One Lakefront. Experience expansive living spaces in Seattle's vibrant Westlake neighborhood.",
      "page_copy": "One Lakefront presents spacious 3 bedroom apartments conveniently located near the 98109 area, perfect for families or those desiring more space. Our apartments feature high-end finishes such as quartz countertops and CAT-6 wiring for optimal connectivity.\n\nExperience the beauty of Seattle living with stunning Lake Union views and direct access to both Westlake Avenue and Dexter Avenue. Community amenities like 'The Boardroom' offer residents exclusive spaces to unwind and connect. Choose One Lakefront for a premier living experience in the heart of Westlake, where city life and natural beauty converge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 98109",
      "seo_description": "Discover spacious 3 bedroom apartments at One Lakefront, near 98109. Enjoy luxury living in Seattle's Westlake neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-washington-seattle",
      "search_query": "apartments near university of washington seattle",
      "category": "School",
      "h1_title": "Prime Apartments Near University of Washington",
      "h2_subtitle": "Explore modern apartments near the University of Washington at One Lakefront. Enjoy living in the vibrant Westlake neighborhood.",
      "page_copy": "Located just a short commute from the University of Washington, One Lakefront offers ideal apartments for students and faculty seeking the best of Seattle living. Our Westlake community features modern conveniences such as quartz countertops and CAT-6 wiring to keep you connected.\n\nImmerse yourself in the bustling atmosphere of Seattle while enjoying the serenity of lakeside views. With indoor access to both Westlake Avenue and Dexter Avenue, residents benefit from excellent transportation links. One Lakefront provides the perfect balance of academic proximity and lifestyle, making it a top choice for university affiliates.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Washington",
      "seo_description": "Find convenient apartments at One Lakefront, close to the University of Washington. Ideal for students in Seattle's Westlake area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "one-lakefront-apartments-by-seattle-central-college",
      "search_query": "one lakefront apartments by seattle central college",
      "category": "School",
      "h1_title": "One Lakefront Apartments Near Seattle Central",
      "h2_subtitle": "Discover One Lakefront's prime location near Seattle Central College. Enjoy modern amenities and a vibrant lifestyle in Westlake.",
      "page_copy": "One Lakefront offers the perfect blend of convenience and comfort for those seeking apartments near Seattle Central College. Located in the lively Westlake neighborhood, our community provides a quick commute to campus while featuring premium amenities like quartz countertops and CAT-6 wiring.\n\nResidents enjoy the best of Seattle living with stunning Lake Union views and eco-friendly double pane windows. The property's central location offers indoor access to Westlake Avenue and Dexter Avenue, ensuring easy connectivity around the city. Choose One Lakefront for an exceptional living experience tailored to students and professionals alike.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Lakefront Apartments by Seattle Central",
      "seo_description": "Explore One Lakefront Apartments, conveniently located near Seattle Central College. Enjoy modern living in the vibrant Westlake area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "apartments-close-to-seattle-university-westlake",
      "search_query": "apartments close to seattle university westlake",
      "category": "School",
      "h1_title": "Apartments Near Seattle University in Westlake",
      "h2_subtitle": "Explore modern living in Westlake with apartments close to Seattle University. Discover comfort and convenience at One Lakefront.",
      "page_copy": "Located in the heart of Westlake, One Lakefront offers premium apartments close to Seattle University, providing students and professionals alike with an ideal and convenient location. Our spacious units come equipped with modern features such as quartz countertops and CAT-6 wiring to enhance your living experience.\n\nResidents can enjoy the vibrant atmosphere of Seattle with ease, thanks to indoor access to Westlake Avenue and Dexter Avenue, perfect for seamless transportation. With amenities like The Boardroom lounge and stunning Lake Union views, One Lakefront ensures a lifestyle of comfort and community within Seattle’s dynamic environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle University Westlake",
      "seo_description": "Find deluxe apartments at One Lakefront, close to Seattle University in Westlake. Enjoy a blend of comfort and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "north-seattle-college-vicinity-apartments-king-county",
      "search_query": "north seattle college vicinity apartments king county",
      "category": "School",
      "h1_title": "North Seattle College Vicinity Apartments",
      "h2_subtitle": "Discover comfortable living near North Seattle College. One Lakefront in King County offers premium amenities and convenience.",
      "page_copy": "Positioned within King County, One Lakefront provides an exceptional living experience for those seeking apartments near North Seattle College. Enjoy a quick commute while living in a community that emphasizes both style and functionality with features like double pane windows and quartz countertops.\n\nSituated in the scenic Westlake neighborhood, our apartments offer easy access to local amenities and public transport routes via Westlake Avenue and Dexter Avenue. The unique mix of lakeside tranquility and urban convenience makes One Lakefront the perfect home base for students and professionals pursuing education and careers in the North Seattle area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near North Seattle College, King County",
      "seo_description": "Explore One Lakefront's King County apartments near North Seattle College. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-childrens-hospital-westlake",
      "search_query": "apartments near Seattle Children's Hospital Westlake",
      "category": "Hospital",
      "h1_title": "Apartments Near Seattle Children's Hospital",
      "h2_subtitle": "Find comfort and convenience at One Lakefront, close to Seattle Children's Hospital in the vibrant Westlake neighborhood.",
      "page_copy": "One Lakefront provides premium living spaces ideally situated near Seattle Children's Hospital in the bustling Westlake district. Our apartments offer a harmonious blend of comfort and style, featuring high-end amenities like CAT-6 wiring and quartz countertops with elegant tile backsplashes.\n\nEnjoy easy access to essential services and a lively community atmosphere with indoor connectivity to both Westlake Avenue and Dexter Avenue. Our residents benefit from a perfect location that offers both the tranquility of lakeside living and the conveniences of city life, making One Lakefront an excellent choice for healthcare professionals and families alike.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle Children's Hospital",
      "seo_description": "Discover One Lakefront Apartments near Seattle Children's Hospital, offering premium living in Westlake with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "apartments-close-to-harborview-medical-center-seattle",
      "search_query": "apartments close to Harborview Medical Center Seattle",
      "category": "Hospital",
      "h1_title": "Apartments Near Harborview Medical Center",
      "h2_subtitle": "Experience unparalleled convenience with apartments close to Harborview Medical Center. One Lakefront offers luxury living in Seattle's vibrant Westlake.",
      "page_copy": "One Lakefront is situated perfectly for those seeking apartments close to Harborview Medical Center in Seattle. Our community provides a blend of modern amenities and convenient access, making it ideal for healthcare professionals and staff.\n\nLocated in the lively Westlake neighborhood, residents of One Lakefront enjoy easy access to main thoroughfares like Westlake Avenue and Dexter Avenue. The apartments boast luxurious features such as quartz countertops and double pane windows, ensuring a serene and stylish living experience. Enjoy the proximity to downtown Seattle and unwind in our exclusive Boardroom Lounge overlooking Lake Union.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Harborview Medical Center in Seattle",
      "seo_description": "Find luxury living at One Lakefront, conveniently located near Harborview Medical Center in Seattle. Enjoy modern amenities and vibrant surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "apartments-near-kerry-park-seattle",
      "search_query": "apartments near kerry park seattle",
      "category": "Park",
      "h1_title": "Apartments Near Kerry Park, Seattle",
      "h2_subtitle": "Experience the luxury of living near Kerry Park in Seattle. One Lakefront offers scenic views and modern amenities in the Westlake neighborhood.",
      "page_copy": "Discover the captivating charm of living near Kerry Park in Seattle at One Lakefront. Our apartments offer a luxurious lifestyle with breathtaking views and a host of modern amenities. Perfectly located, you'll enjoy proximity to one of the most iconic viewpoints in the city.\n\nSituated in Westlake, our community combines the beauty of lakeside living with urban convenience. Residents benefit from sophisticated features such as quartz countertops, CAT-6 wiring, and a chic Boardroom Lounge. With the added advantage of easy access to main routes, One Lakefront offers an ideal location for enjoying all that Seattle has to offer, just moments from Kerry Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kerry Park in Seattle",
      "seo_description": "Live luxuriously near Kerry Park, Seattle at One Lakefront. Enjoy scenic views, modern amenities, and a prime Westlake location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "westlake-apartments-close-to-discovery-park",
      "search_query": "westlake apartments close to discovery park",
      "category": "Park",
      "h1_title": "Westlake Apartments Near Discovery Park",
      "h2_subtitle": "Embrace the tranquility of Westlake living close to Discovery Park. One Lakefront offers luxury and convenience in one beautiful package.",
      "page_copy": "Nestled in the vibrant Westlake area, One Lakefront provides an ideal setting for those seeking apartments close to Discovery Park. Experience a seamless blend of urban living with easy access to Seattle’s largest green space, offering extensive trails and breathtaking views.\n\nOur luxurious apartments at One Lakefront are thoughtfully designed with features like double pane windows and CAT-6 wiring, ensuring comfort and high-quality living. Residents enjoy the added benefits of the Boardroom Lounge and indoor access to major avenues, making One Lakefront the perfect home base for nature enthusiasts who appreciate proximity to Discovery Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Westlake Apartments Near Discovery Park",
      "seo_description": "Find ideal Westlake apartments near Discovery Park at One Lakefront. Enjoy luxury living and easy access to Seattle's premier park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "apartments-near-u-district-seattle",
      "search_query": "apartments near U District Seattle",
      "category": "Transit",
      "h1_title": "Apartments Near U District, Seattle",
      "h2_subtitle": "Explore vibrant living with apartments near U District Seattle. One Lakefront offers modern features and a prime location in Westlake.",
      "page_copy": "Conveniently located in Seattle's dynamic Westlake neighborhood, One Lakefront is a top choice for those seeking apartments near U District Seattle. With a short commute from the University District, our community allows residents to relish both academic and lakeside adventures.\n\nOne Lakefront boasts cutting-edge amenities such as quartz countertops and CAT-6 wiring for superior connectivity. Residents can enjoy indoor access to both Westlake Avenue and Dexter Avenue, providing unparalleled convenience. Whether you're a student or faculty member, enjoy the luxurious style and proximity offered by One Lakefront, perfectly situated near Seattle's U District.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near U District in Seattle",
      "seo_description": "Discover One Lakefront's proximity to U District Seattle. Enjoy modern amenities and an ideal Westlake location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "apartments-close-to-westlake-neighborhood-98109",
      "search_query": "apartments close to Westlake neighborhood 98109",
      "category": "Transit",
      "h1_title": "Apartments Close to Westlake, 98109",
      "h2_subtitle": "Find luxury apartments close to the Westlake neighborhood, 98109. One Lakefront offers modern amenities in a scenic location.",
      "page_copy": "One Lakefront provides a premier living experience close to the charming Westlake neighborhood in the 98109 area. Enjoy the vibrant combination of lakeside vistas and urban excitement right from your doorstep.\n\nOur community features exquisite amenities such as quartz countertops, double pane windows, and CAT-6 wiring for optimal speed and connectivity. The Boardroom Lounge offers residents a perfect retreat with recreational features. With convenient access to Westlake Avenue and Dexter Avenue, One Lakefront embodies the ideal home for those wanting proximity to Westlake's delights while luxuriating in contemporary comforts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Westlake, 98109",
      "seo_description": "Discover luxury living at One Lakefront, close to Westlake neighborhood, 98109. Experience modern amenities in a prime Seattle location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "university-of-washington-station-nearby-apartments",
      "search_query": "University of Washington Station nearby apartments",
      "category": "Transit",
      "h1_title": "Apartments Near University of Washington Station",
      "h2_subtitle": "Live conveniently with nearby access to University of Washington Station. Discover upscale living at One Lakefront, strategically located in Westlake.",
      "page_copy": "One Lakefront is an ideal choice for those seeking apartments near University of Washington Station, providing seamless connectivity to the heart of Seattle. Situated in the lively Westlake neighborhood, our community delivers both style and convenience.\n\nFeaturing modern amenities like quartz countertops and CAT-6 wiring, residents can enjoy both luxury and functionality. Our indoor accessibility to Westlake Avenue and Dexter Avenue enhances urban living. Whether commuting to campus or exploring Seattle, One Lakefront offers a perfect balance of comfort and proximity to University of Washington Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Washington Station",
      "seo_description": "Find stylish apartments near University of Washington Station at One Lakefront, offering modern amenities and ideal Seattle access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "apartments-near-symphony-transit-king-county",
      "search_query": "apartments near Symphony transit King County",
      "category": "Transit",
      "h1_title": "Apartments Near Symphony Transit King County",
      "h2_subtitle": "Discover convenient apartments near Symphony transit in King County. Enjoy upscale living at One Lakefront, located in Westlake, Seattle.",
      "page_copy": "Located in the picturesque Westlake area, One Lakefront offers a perfect setting for those searching for apartments near Symphony transit in King County. Our community is strategically positioned to provide residents with seamless access to public transit options, enhancing their Seattle lifestyle.\n\nResidents of One Lakefront enjoy luxurious amenities, including quartz countertops and double pane windows, paired with high-speed CAT-6 wiring. With direct access to Westlake Avenue and Dexter Avenue, commuting is a breeze. Experience the convenience of Symphony transit nearby while enjoying the upscale lifestyle at One Lakefront.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Symphony Transit in King County",
      "seo_description": "Explore One Lakefront's nearby transit options in King County. Live in style with modern amenities and easy access to Symphony transit.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162273",
      "property_id": "6767906449167762",
      "source": "generator",
      "page_item_url": "roosevelt-seattle-nearby-apartments",
      "search_query": "Roosevelt Seattle nearby apartments",
      "category": "Transit",
      "h1_title": "Nearby Apartments in Roosevelt, Seattle",
      "h2_subtitle": "Explore upscale living options with nearby access to Roosevelt, Seattle. One Lakefront offers modern amenities in Westlake, near Roosevelt.",
      "page_copy": "Experience the best of Seattle by choosing One Lakefront, offering apartments with convenient access to Roosevelt. Nestled in the scenic Westlake neighborhood, our community provides a perfect blend of luxury, comfort, and proximity to the vibrant Roosevelt area.\n\nOur residents enjoy modern amenities such as quartz countertops, double pane windows, and high-speed CAT-6 wiring. The Boardroom Lounge is a unique leisure space featuring a pool table and large flat screen TV. With indoor access routes leading to Westlake Avenue and Dexter Avenue, exploring the excitement of Roosevelt from One Lakefront is both easy and enjoyable.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments in Roosevelt, Seattle",
      "seo_description": "Find premium apartments at One Lakefront with easy access to Roosevelt, Seattle. Enjoy modern amenities in the vibrant Westlake neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": []
};

export const generatedAt = '2026-10-21T21:36:49.721Z';
